function OnboardImage1Dark() {
  return (
    <svg style={{ width: '100%' }} viewBox='0 0 390 493' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3383_11459)'>
        <g opacity='0.6'>
          <rect opacity='0.5' x='178.417' y='73.5273' width='52.0273' height='52.0273' stroke='#391998' />
          <rect opacity='0.5' x='284.032' y='20.5' width='52.0273' height='52.0273' stroke='#391998' />
          <rect opacity='0.5' x='284.032' y='126.554' width='52.0273' height='52.0273' stroke='#391998' />
          <rect opacity='0.5' x='337.058' y='126.554' width='52.0273' height='52.0273' stroke='#391998' />
          <rect opacity='0.5' x='125.5' y='179.503' width='52.0273' height='52.0273' stroke='#391998' />
          <rect x='231.446' y='73.5273' width='52.0273' height='52.0273' stroke='#391998' />
          <rect x='231.446' y='126.554' width='52.0273' height='52.0273' stroke='#391998' />
          <rect
            x='336.058'
            y='73.5273'
            width='52.0273'
            height='52.0273'
            transform='rotate(90 336.058 73.5273)'
            stroke='#391998'
          />
          <rect x='178.417' y='126.554' width='52.0273' height='52.0273' stroke='#391998' />
          <rect x='284.032' y='179.582' width='52.0273' height='52.0273' stroke='#391998' />
          <rect x='178.417' y='179.582' width='52.0273' height='52.0273' stroke='#391998' />
          <rect
            x='283.032'
            y='20.5'
            width='52.0273'
            height='52.0273'
            transform='rotate(90 283.032 20.5)'
            stroke='#391998'
          />
          <rect
            x='389.085'
            y='20.5'
            width='52.0273'
            height='52.0273'
            transform='rotate(90 389.085 20.5)'
            stroke='#391998'
          />
        </g>
        <g opacity='0.6'>
          <rect
            opacity='0.5'
            x='166.168'
            y='415.582'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 166.168 415.582)'
            stroke='#391998'
          />
          <rect
            opacity='0.5'
            x='60.5532'
            y='468.609'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 60.5532 468.609)'
            stroke='#391998'
          />
          <rect
            opacity='0.5'
            x='60.5532'
            y='362.554'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 60.5532 362.554)'
            stroke='#391998'
          />
          <rect
            opacity='0.5'
            x='7.52722'
            y='362.554'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 7.52722 362.554)'
            stroke='#391998'
          />
          <rect
            opacity='0.5'
            x='219.085'
            y='309.605'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 219.085 309.605)'
            stroke='#391998'
          />
          <rect
            x='113.139'
            y='415.582'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 113.139 415.582)'
            stroke='#391998'
          />
          <rect
            x='113.139'
            y='362.554'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 113.139 362.554)'
            stroke='#391998'
          />
          <rect
            x='8.52722'
            y='415.582'
            width='52.0273'
            height='52.0273'
            transform='rotate(-90 8.52722 415.582)'
            stroke='#391998'
          />
          <rect
            x='166.168'
            y='362.554'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 166.168 362.554)'
            stroke='#391998'
          />
          <rect
            x='60.5532'
            y='309.527'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 60.5532 309.527)'
            stroke='#391998'
          />
          <rect
            x='166.168'
            y='309.527'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 166.168 309.527)'
            stroke='#391998'
          />
          <rect
            x='61.5532'
            y='468.609'
            width='52.0273'
            height='52.0273'
            transform='rotate(-90 61.5532 468.609)'
            stroke='#391998'
          />
          <rect
            x='-44.5'
            y='468.609'
            width='52.0273'
            height='52.0273'
            transform='rotate(-90 -44.5 468.609)'
            stroke='#391998'
          />
        </g>
        <path
          d='M73.8826 290.291L56.9782 295.048L49.6051 268.846L66.5095 264.089L73.8826 290.291Z'
          fill='url(#paint0_linear_3383_11459)'
        />
        <path
          d='M50.4798 291.403L45.9608 275.344L51.0321 273.917L55.5511 289.976L50.4798 291.403Z'
          fill='url(#paint1_linear_3383_11459)'
        />
        <path
          d='M71.6104 285.457L67.0914 269.398L72.1627 267.971L76.6817 284.03L71.6104 285.457Z'
          fill='url(#paint2_linear_3383_11459)'
        />
        <rect
          x='46.4916'
          y='293.438'
          width='17.561'
          height='4.39024'
          transform='rotate(-105.716 46.4916 293.438)'
          fill='#D9D9D9'
        />
        <rect
          x='66.5096'
          y='264.089'
          width='17.561'
          height='4.39024'
          transform='rotate(164.284 66.5096 264.089)'
          fill='#D9D9D9'
        />
        <rect
          x='75.0719'
          y='294.517'
          width='17.561'
          height='4.39024'
          transform='rotate(164.284 75.0719 294.517)'
          fill='#D9D9D9'
        />
        <rect
          x='56.9783'
          y='295.048'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 56.9783 295.048)'
          fill='#D9D9D9'
        />
        <rect
          x='51.0322'
          y='273.917'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 51.0322 273.917)'
          fill='#D9D9D9'
        />
        <rect
          x='78.954'
          y='288.864'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 78.954 288.864)'
          fill='#D9D9D9'
        />
        <rect
          x='73.0079'
          y='267.733'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 73.0079 267.733)'
          fill='#D9D9D9'
        />
        <rect
          x='76.9196'
          y='284.875'
          width='17.561'
          height='4.39024'
          transform='rotate(-105.716 76.9196 284.875)'
          fill='#D9D9D9'
        />
        <path
          d='M155.82 313.861L147.068 309.6L153.673 296.034L162.426 300.295L155.82 313.861Z'
          fill='url(#paint3_linear_3383_11459)'
        />
        <path
          d='M145.721 305.695L149.769 297.381L152.395 298.659L148.346 306.974L145.721 305.695Z'
          fill='url(#paint4_linear_3383_11459)'
        />
        <path
          d='M156.661 311.023L160.709 302.708L163.335 303.986L159.286 312.301L156.661 311.023Z'
          fill='url(#paint5_linear_3383_11459)'
        />
        <rect
          x='143.319'
          y='305.068'
          width='9.73465'
          height='2.43366'
          transform='rotate(-64.0372 143.319 305.068)'
          fill='#D9D9D9'
        />
        <rect
          x='162.426'
          y='300.295'
          width='9.73465'
          height='2.43366'
          transform='rotate(-154.037 162.426 300.295)'
          fill='#D9D9D9'
        />
        <rect
          x='154.754'
          y='316.049'
          width='9.73465'
          height='2.43366'
          transform='rotate(-154.037 154.754 316.049)'
          fill='#D9D9D9'
        />
        <rect
          x='147.068'
          y='309.6'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 147.068 309.6)'
          fill='#D9D9D9'
        />
        <rect
          x='152.395'
          y='298.659'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 152.395 298.659)'
          fill='#D9D9D9'
        />
        <rect
          x='158.446'
          y='315.14'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 158.446 315.14)'
          fill='#D9D9D9'
        />
        <rect
          x='163.773'
          y='304.199'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 163.773 304.199)'
          fill='#D9D9D9'
        />
        <rect
          x='159.073'
          y='312.739'
          width='9.73465'
          height='2.43366'
          transform='rotate(-64.0372 159.073 312.739)'
          fill='#D9D9D9'
        />
        <path
          d='M130.458 405.901L120.915 407.824L117.934 393.032L127.477 391.109L130.458 405.901Z'
          fill='url(#paint6_linear_3383_11459)'
        />
        <path
          d='M117.475 405.538L115.648 396.472L118.511 395.895L120.338 404.961L117.475 405.538Z'
          fill='url(#paint7_linear_3383_11459)'
        />
        <path
          d='M129.404 403.134L127.577 394.068L130.44 393.491L132.267 402.557L129.404 403.134Z'
          fill='url(#paint8_linear_3383_11459)'
        />
        <rect
          x='115.186'
          y='406.495'
          width='9.73465'
          height='2.43366'
          transform='rotate(-101.393 115.186 406.495)'
          fill='#D9D9D9'
        />
        <rect
          x='127.477'
          y='391.109'
          width='9.73465'
          height='2.43366'
          transform='rotate(168.607 127.477 391.109)'
          fill='#D9D9D9'
        />
        <rect
          x='130.938'
          y='408.286'
          width='9.73465'
          height='2.43366'
          transform='rotate(168.607 130.938 408.286)'
          fill='#D9D9D9'
        />
        <rect
          x='120.915'
          y='407.823'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 120.915 407.823)'
          fill='#D9D9D9'
        />
        <rect
          x='118.511'
          y='395.895'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 118.511 395.895)'
          fill='#D9D9D9'
        />
        <rect
          x='133.321'
          y='405.324'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 133.321 405.324)'
          fill='#D9D9D9'
        />
        <rect
          x='130.917'
          y='393.395'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 130.917 393.395)'
          fill='#D9D9D9'
        />
        <rect
          x='132.363'
          y='403.034'
          width='9.73465'
          height='2.43366'
          transform='rotate(-101.393 132.363 403.034)'
          fill='#D9D9D9'
        />
        <path
          d='M190.787 370.976L183.487 364.536L193.468 353.22L200.768 359.66L190.787 370.976Z'
          fill='url(#paint9_linear_3383_11459)'
        />
        <path
          d='M183.228 360.414L189.346 353.479L191.536 355.411L185.418 362.346L183.228 360.414Z'
          fill='url(#paint10_linear_3383_11459)'
        />
        <path
          d='M192.354 368.463L198.471 361.528L200.662 363.46L194.544 370.395L192.354 368.463Z'
          fill='url(#paint11_linear_3383_11459)'
        />
        <rect
          x='181.081'
          y='359.169'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 181.081 359.169)'
          fill='#D9D9D9'
        />
        <rect
          x='200.768'
          y='359.66'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 200.768 359.66)'
          fill='#D9D9D9'
        />
        <rect
          x='189.177'
          y='372.801'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 189.177 372.801)'
          fill='#D9D9D9'
        />
        <rect
          x='183.487'
          y='364.536'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 183.487 364.536)'
          fill='#D9D9D9'
        />
        <rect
          x='191.536'
          y='355.411'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 191.536 355.411)'
          fill='#D9D9D9'
        />
        <rect
          x='192.977'
          y='372.908'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 192.977 372.908)'
          fill='#D9D9D9'
        />
        <rect
          x='201.026'
          y='363.782'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 201.026 363.782)'
          fill='#D9D9D9'
        />
        <rect
          x='194.222'
          y='370.76'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 194.222 370.76)'
          fill='#D9D9D9'
        />
        <path
          d='M291.147 357.848L283.846 351.409L293.827 340.093L301.128 346.532L291.147 357.848Z'
          fill='url(#paint12_linear_3383_11459)'
        />
        <path
          d='M283.588 347.287L289.705 340.351L291.896 342.283L285.778 349.219L283.588 347.287Z'
          fill='url(#paint13_linear_3383_11459)'
        />
        <path
          d='M292.714 355.336L298.831 348.401L301.021 350.332L294.904 357.268L292.714 355.336Z'
          fill='url(#paint14_linear_3383_11459)'
        />
        <rect
          x='281.441'
          y='346.042'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 281.441 346.042)'
          fill='#D9D9D9'
        />
        <rect
          x='301.128'
          y='346.532'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 301.128 346.532)'
          fill='#D9D9D9'
        />
        <rect
          x='289.537'
          y='359.673'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 289.537 359.673)'
          fill='#D9D9D9'
        />
        <rect
          x='283.846'
          y='351.409'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 283.846 351.409)'
          fill='#D9D9D9'
        />
        <rect
          x='291.896'
          y='342.283'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 291.896 342.283)'
          fill='#D9D9D9'
        />
        <rect
          x='293.337'
          y='359.78'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 293.337 359.78)'
          fill='#D9D9D9'
        />
        <rect
          x='301.386'
          y='350.655'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 301.386 350.655)'
          fill='#D9D9D9'
        />
        <rect
          x='294.582'
          y='357.633'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 294.582 357.633)'
          fill='#D9D9D9'
        />
        <path
          d='M252.072 283.962L247.841 294.904L230.88 288.346L235.111 277.403L252.072 283.962Z'
          fill='url(#paint15_linear_3383_11459)'
        />
        <path
          d='M243.289 296.918L232.893 292.898L234.163 289.615L244.558 293.635L243.289 296.918Z'
          fill='url(#paint16_linear_3383_11459)'
        />
        <path
          d='M248.578 283.24L238.183 279.22L239.452 275.937L249.848 279.957L248.578 283.24Z'
          fill='url(#paint17_linear_3383_11459)'
        />
        <rect
          x='242.778'
          y='299.865'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 242.778 299.865)'
          fill='#D9D9D9'
        />
        <rect
          x='235.111'
          y='277.403'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 235.111 277.403)'
          fill='#D9D9D9'
        />
        <rect
          x='254.808'
          y='285.02'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 254.808 285.02)'
          fill='#D9D9D9'
        />
        <rect
          x='247.841'
          y='294.905'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 247.841 294.905)'
          fill='#D9D9D9'
        />
        <rect
          x='234.163'
          y='289.615'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 234.163 289.615)'
          fill='#D9D9D9'
        />
        <rect
          x='253.342'
          y='280.679'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 253.342 280.679)'
          fill='#D9D9D9'
        />
        <rect
          x='239.664'
          y='275.39'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 239.664 275.39)'
          fill='#D9D9D9'
        />
        <rect
          x='250.395'
          y='280.168'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 250.395 280.168)'
          fill='#D9D9D9'
        />
        <path
          d='M129.376 175.95L125.144 186.893L108.183 180.334L112.415 169.391L129.376 175.95Z'
          fill='url(#paint18_linear_3383_11459)'
        />
        <path
          d='M120.592 188.906L110.197 184.886L111.466 181.603L121.862 185.623L120.592 188.906Z'
          fill='url(#paint19_linear_3383_11459)'
        />
        <path
          d='M125.882 175.228L115.486 171.208L116.756 167.925L127.151 171.945L125.882 175.228Z'
          fill='url(#paint20_linear_3383_11459)'
        />
        <rect
          x='120.081'
          y='191.854'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 120.081 191.854)'
          fill='#D9D9D9'
        />
        <rect
          x='112.415'
          y='169.391'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 112.415 169.391)'
          fill='#D9D9D9'
        />
        <rect
          x='132.111'
          y='177.008'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 132.111 177.008)'
          fill='#D9D9D9'
        />
        <rect
          x='125.144'
          y='186.893'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 125.144 186.893)'
          fill='#D9D9D9'
        />
        <rect
          x='111.466'
          y='181.604'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 111.466 181.604)'
          fill='#D9D9D9'
        />
        <rect
          x='130.645'
          y='172.668'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 130.645 172.668)'
          fill='#D9D9D9'
        />
        <rect
          x='116.967'
          y='167.378'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 116.967 167.378)'
          fill='#D9D9D9'
        />
        <rect
          x='127.698'
          y='172.157'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 127.698 172.157)'
          fill='#D9D9D9'
        />
        <path
          d='M196.239 122.295L184.988 133.563L167.522 116.124L178.773 104.856L196.239 122.295Z'
          fill='url(#paint21_linear_3383_11459)'
        />
        <path
          d='M178.232 133.568L167.528 122.88L170.903 119.499L181.608 130.188L178.232 133.568Z'
          fill='url(#paint22_linear_3383_11459)'
        />
        <path
          d='M192.296 119.483L181.591 108.795L184.967 105.414L195.671 116.102L192.296 119.483Z'
          fill='url(#paint23_linear_3383_11459)'
        />
        <rect
          x='175.983'
          y='136.948'
          width='15.9234'
          height='3.98084'
          transform='rotate(-135.044 175.983 136.948)'
          fill='#D9D9D9'
        />
        <rect
          x='178.773'
          y='104.856'
          width='15.9234'
          height='3.98084'
          transform='rotate(134.956 178.773 104.856)'
          fill='#D9D9D9'
        />
        <rect
          x='199.056'
          y='125.108'
          width='15.9234'
          height='3.98084'
          transform='rotate(134.956 199.056 125.108)'
          fill='#D9D9D9'
        />
        <rect
          x='184.988'
          y='133.563'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 184.988 133.563)'
          fill='#D9D9D9'
        />
        <rect
          x='170.903'
          y='119.5'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 170.903 119.5)'
          fill='#D9D9D9'
        />
        <rect
          x='199.614'
          y='118.915'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 199.614 118.915)'
          fill='#D9D9D9'
        />
        <rect
          x='185.529'
          y='104.851'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 185.529 104.851)'
          fill='#D9D9D9'
        />
        <rect
          x='196.235'
          y='116.665'
          width='15.9234'
          height='3.98084'
          transform='rotate(-135.044 196.235 116.665)'
          fill='#D9D9D9'
        />
        <path
          d='M241.345 174.547L233.403 180.257L224.552 167.947L232.494 162.237L241.345 174.547Z'
          fill='url(#paint24_linear_3383_11459)'
        />
        <path
          d='M229.307 179.588L223.883 172.043L226.265 170.33L231.69 177.875L229.307 179.588Z'
          fill='url(#paint25_linear_3383_11459)'
        />
        <path
          d='M239.235 172.45L233.81 164.905L236.193 163.192L241.617 170.737L239.235 172.45Z'
          fill='url(#paint26_linear_3383_11459)'
        />
        <rect
          x='227.607'
          y='181.413'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 227.607 181.413)'
          fill='#D9D9D9'
        />
        <rect
          x='232.494'
          y='162.238'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 232.494 162.238)'
          fill='#D9D9D9'
        />
        <rect
          x='242.772'
          y='176.533'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 242.772 176.533)'
          fill='#D9D9D9'
        />
        <rect
          x='233.403'
          y='180.257'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 233.403 180.257)'
          fill='#D9D9D9'
        />
        <rect
          x='226.265'
          y='170.33'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 226.265 170.33)'
          fill='#D9D9D9'
        />
        <rect
          x='243.727'
          y='172.834'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 243.727 172.834)'
          fill='#D9D9D9'
        />
        <rect
          x='236.59'
          y='162.907'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 236.59 162.907)'
          fill='#D9D9D9'
        />
        <rect
          x='241.903'
          y='171.134'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 241.903 171.134)'
          fill='#D9D9D9'
        />
        <path
          d='M316.105 285.74L308.164 291.451L299.313 279.141L307.255 273.43L316.105 285.74Z'
          fill='url(#paint27_linear_3383_11459)'
        />
        <path
          d='M304.068 290.781L298.643 283.236L301.026 281.523L306.451 289.068L304.068 290.781Z'
          fill='url(#paint28_linear_3383_11459)'
        />
        <path
          d='M313.995 283.643L308.571 276.099L310.953 274.385L316.378 281.93L313.995 283.643Z'
          fill='url(#paint29_linear_3383_11459)'
        />
        <rect
          x='302.368'
          y='292.606'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 302.368 292.606)'
          fill='#D9D9D9'
        />
        <rect
          x='307.255'
          y='273.431'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 307.255 273.431)'
          fill='#D9D9D9'
        />
        <rect
          x='317.533'
          y='287.726'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 317.533 287.726)'
          fill='#D9D9D9'
        />
        <rect
          x='308.163'
          y='291.45'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 308.163 291.45)'
          fill='#D9D9D9'
        />
        <rect
          x='301.026'
          y='281.523'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 301.026 281.523)'
          fill='#D9D9D9'
        />
        <rect
          x='318.488'
          y='284.028'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 318.488 284.028)'
          fill='#D9D9D9'
        />
        <rect
          x='311.35'
          y='274.1'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 311.35 274.1)'
          fill='#D9D9D9'
        />
        <rect
          x='316.663'
          y='282.327'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 316.663 282.327)'
          fill='#D9D9D9'
        />
        <path
          d='M317.001 185.567L309.858 192.249L299.5 181.177L306.644 174.495L317.001 185.567Z'
          fill='url(#paint30_linear_3383_11459)'
        />
        <path
          d='M305.71 192.111L299.362 185.325L301.505 183.32L307.853 190.106L305.71 192.111Z'
          fill='url(#paint31_linear_3383_11459)'
        />
        <path
          d='M314.639 183.758L308.291 176.972L310.434 174.967L316.782 181.753L314.639 183.758Z'
          fill='url(#paint32_linear_3383_11459)'
        />
        <rect
          x='304.259'
          y='194.139'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 304.259 194.139)'
          fill='#D9D9D9'
        />
        <rect
          x='306.644'
          y='174.495'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 306.644 174.495)'
          fill='#D9D9D9'
        />
        <rect
          x='318.672'
          y='187.353'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 318.672 187.353)'
          fill='#D9D9D9'
        />
        <rect
          x='309.858'
          y='192.249'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 309.858 192.249)'
          fill='#D9D9D9'
        />
        <rect
          x='301.505'
          y='183.321'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 301.505 183.321)'
          fill='#D9D9D9'
        />
        <rect
          x='319.144'
          y='183.562'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 319.144 183.562)'
          fill='#D9D9D9'
        />
        <rect
          x='310.791'
          y='174.634'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 310.791 174.634)'
          fill='#D9D9D9'
        />
        <rect
          x='317.116'
          y='182.111'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 317.116 182.111)'
          fill='#D9D9D9'
        />
        <path
          d='M302.892 131.675L295.749 138.358L285.392 127.286L292.535 120.603L302.892 131.675Z'
          fill='url(#paint33_linear_3383_11459)'
        />
        <path
          d='M291.602 138.22L285.253 131.434L287.396 129.429L293.745 136.215L291.602 138.22Z'
          fill='url(#paint34_linear_3383_11459)'
        />
        <path
          d='M300.531 129.867L294.182 123.081L296.325 121.076L302.674 127.862L300.531 129.867Z'
          fill='url(#paint35_linear_3383_11459)'
        />
        <rect
          x='290.15'
          y='140.248'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 290.15 140.248)'
          fill='#D9D9D9'
        />
        <rect
          x='292.535'
          y='120.604'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 292.535 120.604)'
          fill='#D9D9D9'
        />
        <rect
          x='304.563'
          y='133.461'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 304.563 133.461)'
          fill='#D9D9D9'
        />
        <rect
          x='295.749'
          y='138.358'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 295.749 138.358)'
          fill='#D9D9D9'
        />
        <rect
          x='287.396'
          y='129.429'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 287.396 129.429)'
          fill='#D9D9D9'
        />
        <rect
          x='305.035'
          y='129.671'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 305.035 129.671)'
          fill='#D9D9D9'
        />
        <rect
          x='296.682'
          y='120.742'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 296.682 120.742)'
          fill='#D9D9D9'
        />
        <rect
          x='303.008'
          y='128.219'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 303.008 128.219)'
          fill='#D9D9D9'
        />
        <path
          d='M272.223 223.784L278.113 234.918L260.854 244.047L254.965 232.913L272.223 223.784Z'
          fill='url(#paint36_linear_3383_11459)'
        />
        <path
          d='M276.54 240.026L265.962 245.621L264.195 242.28L274.773 236.685L276.54 240.026Z'
          fill='url(#paint37_linear_3383_11459)'
        />
        <path
          d='M269.178 226.107L258.6 231.702L256.833 228.362L267.411 222.767L269.178 226.107Z'
          fill='url(#paint38_linear_3383_11459)'
        />
        <rect
          x='278.569'
          y='242.515'
          width='12.5964'
          height='3.14911'
          transform='rotate(152.124 278.569 242.515)'
          fill='#D9D9D9'
        />
        <rect
          x='254.965'
          y='232.913'
          width='12.5964'
          height='3.14911'
          transform='rotate(62.1237 254.965 232.913)'
          fill='#D9D9D9'
        />
        <rect
          x='275.007'
          y='222.312'
          width='12.5964'
          height='3.14911'
          transform='rotate(62.1237 275.007 222.312)'
          fill='#D9D9D9'
        />
        <rect
          x='278.113'
          y='234.918'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 278.113 234.918)'
          fill='#D9D9D9'
        />
        <rect
          x='264.195'
          y='242.281'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 264.195 242.281)'
          fill='#D9D9D9'
        />
        <rect
          x='270.457'
          y='220.444'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 270.457 220.444)'
          fill='#D9D9D9'
        />
        <rect
          x='256.539'
          y='227.805'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 256.539 227.805)'
          fill='#D9D9D9'
        />
        <rect
          x='267.967'
          y='222.473'
          width='12.5964'
          height='3.14911'
          transform='rotate(152.124 267.967 222.473)'
          fill='#D9D9D9'
        />
        <path
          d='M72.8293 225.275L69.9951 232.604L58.6352 228.211L61.4694 220.882L72.8293 225.275Z'
          fill='url(#paint39_linear_3383_11459)'
        />
        <path
          d='M66.9462 233.952L59.9837 231.26L60.8339 229.061L67.7964 231.754L66.9462 233.952Z'
          fill='url(#paint40_linear_3383_11459)'
        />
        <path
          d='M70.4889 224.791L63.5263 222.099L64.3766 219.9L71.3391 222.593L70.4889 224.791Z'
          fill='url(#paint41_linear_3383_11459)'
        />
        <rect
          x='66.6041'
          y='235.926'
          width='7.85789'
          height='1.96447'
          transform='rotate(-158.858 66.6041 235.926)'
          fill='#D9D9D9'
        />
        <rect
          x='61.4694'
          y='220.882'
          width='7.85789'
          height='1.96447'
          transform='rotate(111.142 61.4694 220.882)'
          fill='#D9D9D9'
        />
        <rect
          x='74.6615'
          y='225.984'
          width='7.85789'
          height='1.96447'
          transform='rotate(111.142 74.6615 225.984)'
          fill='#D9D9D9'
        />
        <rect
          x='69.995'
          y='232.604'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 69.995 232.604)'
          fill='#D9D9D9'
        />
        <rect
          x='60.834'
          y='229.062'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 60.834 229.062)'
          fill='#D9D9D9'
        />
        <rect
          x='73.6796'
          y='223.076'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 73.6796 223.076)'
          fill='#D9D9D9'
        />
        <rect
          x='64.5184'
          y='219.534'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 64.5184 219.534)'
          fill='#D9D9D9'
        />
        <rect
          x='71.7056'
          y='222.734'
          width='7.85789'
          height='1.96447'
          transform='rotate(-158.858 71.7056 222.734)'
          fill='#D9D9D9'
        />
        <path
          d='M202.92 246.182L181.524 252.203L172.191 219.039L193.588 213.018L202.92 246.182Z'
          fill='url(#paint42_linear_3383_11459)'
        />
        <path
          d='M173.298 247.591L167.578 227.264L173.997 225.458L179.717 245.784L173.298 247.591Z'
          fill='url(#paint43_linear_3383_11459)'
        />
        <path
          d='M200.044 240.064L194.324 219.738L200.743 217.931L206.463 238.258L200.044 240.064Z'
          fill='url(#paint44_linear_3383_11459)'
        />
        <rect
          x='168.25'
          y='250.166'
          width='22.2276'
          height='5.55689'
          transform='rotate(-105.716 168.25 250.166)'
          fill='#D9D9D9'
        />
        <rect
          x='193.588'
          y='213.018'
          width='22.2276'
          height='5.55689'
          transform='rotate(164.284 193.588 213.018)'
          fill='#D9D9D9'
        />
        <rect
          x='204.425'
          y='251.532'
          width='22.2276'
          height='5.55689'
          transform='rotate(164.284 204.425 251.532)'
          fill='#D9D9D9'
        />
        <rect
          x='181.524'
          y='252.203'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 181.524 252.203)'
          fill='#D9D9D9'
        />
        <rect
          x='173.997'
          y='225.458'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 173.997 225.458)'
          fill='#D9D9D9'
        />
        <rect
          x='209.339'
          y='244.376'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 209.339 244.376)'
          fill='#D9D9D9'
        />
        <rect
          x='201.813'
          y='217.631'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 201.813 217.631)'
          fill='#D9D9D9'
        />
        <rect
          x='206.764'
          y='239.328'
          width='22.2276'
          height='5.55689'
          transform='rotate(-105.716 206.764 239.328)'
          fill='#D9D9D9'
        />
        <rect
          x='62.9459'
          y='381.787'
          width='17.561'
          height='4.39024'
          transform='rotate(-91.4108 62.9459 381.787)'
          fill='#D9D9D9'
        />
        <rect
          x='89.5951'
          y='358.294'
          width='17.561'
          height='4.39024'
          transform='rotate(178.589 89.5951 358.294)'
          fill='#D9D9D9'
        />
        <rect
          x='90.3734'
          y='389.895'
          width='17.561'
          height='4.39024'
          transform='rotate(178.589 90.3734 389.895)'
          fill='#D9D9D9'
        />
        <rect
          x='72.7096'
          y='385.938'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 72.7096 385.938)'
          fill='#D9D9D9'
        />
        <rect
          x='72.1692'
          y='363.994'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 72.1692 363.994)'
          fill='#D9D9D9'
        />
        <rect
          x='95.532'
          y='385.376'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 95.532 385.376)'
          fill='#D9D9D9'
        />
        <rect
          x='94.9915'
          y='363.432'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 94.9915 363.432)'
          fill='#D9D9D9'
        />
        <rect
          x='94.5461'
          y='381.009'
          width='17.561'
          height='4.39024'
          transform='rotate(-91.4108 94.5461 381.009)'
          fill='#D9D9D9'
        />
        <path
          d='M80.0117 349.856L73.2766 345.723L77.4103 338.987L84.1453 343.121L80.0117 349.856Z'
          fill='url(#paint45_linear_3383_11459)'
        />
        <path
          d='M77.6993 340.195L70.9642 336.061L75.0979 329.326L81.833 333.46L77.6993 340.195Z'
          fill='url(#paint46_linear_3383_11459)'
        />
        <path
          d='M75.3869 330.534L68.6519 326.4L72.7855 319.665L79.5206 323.799L75.3869 330.534Z'
          fill='url(#paint47_linear_3383_11459)'
        />
        <path
          d='M73.0746 320.873L66.3395 316.739L70.4732 310.004L77.2082 314.138L73.0746 320.873Z'
          fill='url(#paint48_linear_3383_11459)'
        />
        <path
          d='M70.0139 310.752L63.2788 306.619L67.4125 299.884L74.1475 304.017L70.0139 310.752Z'
          fill='url(#paint49_linear_3383_11459)'
        />
        <path
          d='M180.258 257.804L182.532 265.372L174.964 267.647L172.69 260.079L180.258 257.804Z'
          fill='url(#paint50_linear_3383_11459)'
        />
        <path
          d='M175.553 266.553L177.827 274.121L170.259 276.396L167.985 268.828L175.553 266.553Z'
          fill='url(#paint51_linear_3383_11459)'
        />
        <path
          d='M170.847 275.302L173.122 282.87L165.554 285.145L163.28 277.577L170.847 275.302Z'
          fill='url(#paint52_linear_3383_11459)'
        />
        <path
          d='M165.554 285.145L167.829 292.713L160.261 294.988L157.986 287.42L165.554 285.145Z'
          fill='url(#paint53_linear_3383_11459)'
        />
        <path
          d='M160.294 317.013L168 318.764L166.249 326.47L158.543 324.719L160.294 317.013Z'
          fill='url(#paint54_linear_3383_11459)'
        />
        <path
          d='M165.587 325.42L173.293 327.171L171.542 334.877L163.836 333.126L165.587 325.42Z'
          fill='url(#paint55_linear_3383_11459)'
        />
        <path
          d='M170.881 333.826L178.586 335.577L176.835 343.283L169.129 341.532L170.881 333.826Z'
          fill='url(#paint56_linear_3383_11459)'
        />
        <path
          d='M176.835 343.283L184.541 345.034L182.79 352.74L175.084 350.989L176.835 343.283Z'
          fill='url(#paint57_linear_3383_11459)'
        />
        <path
          d='M141.539 393.407L144.189 385.963L151.634 388.613L148.984 396.057L141.539 393.407Z'
          fill='url(#paint58_linear_3383_11459)'
        />
        <path
          d='M150.513 389.145L153.163 381.7L160.607 384.35L157.958 391.795L150.513 389.145Z'
          fill='url(#paint59_linear_3383_11459)'
        />
        <path
          d='M159.486 384.883L162.136 377.438L169.581 380.088L166.931 387.533L159.486 384.883Z'
          fill='url(#paint60_linear_3383_11459)'
        />
        <path
          d='M169.581 380.088L172.231 372.643L179.676 375.293L177.026 382.738L169.581 380.088Z'
          fill='url(#paint61_linear_3383_11459)'
        />
        <path
          d='M81.1432 272.643L84.5639 265.52L91.6876 268.94L88.267 276.064L81.1432 272.643Z'
          fill='url(#paint62_linear_3383_11459)'
        />
        <path
          d='M90.516 269.352L93.9367 262.228L101.06 265.649L97.6398 272.772L90.516 269.352Z'
          fill='url(#paint63_linear_3383_11459)'
        />
        <path
          d='M99.8888 266.06L103.31 258.936L110.433 262.357L107.013 269.481L99.8888 266.06Z'
          fill='url(#paint64_linear_3383_11459)'
        />
        <path
          d='M109.262 262.769L112.682 255.645L119.806 259.066L116.385 266.189L109.262 262.769Z'
          fill='url(#paint65_linear_3383_11459)'
        />
        <path
          d='M119.015 258.685L122.435 251.562L129.559 254.982L126.138 262.106L119.015 258.685Z'
          fill='url(#paint66_linear_3383_11459)'
        />
        <path
          d='M129.559 254.982L132.98 247.859L140.103 251.279L136.683 258.403L129.559 254.982Z'
          fill='url(#paint67_linear_3383_11459)'
        />
        <path
          d='M140.62 251.114L144.041 243.99L151.164 247.411L147.744 254.535L140.62 251.114Z'
          fill='url(#paint68_linear_3383_11459)'
        />
        <path
          d='M151.164 247.411L154.585 240.287L161.709 243.708L158.288 250.831L151.164 247.411Z'
          fill='url(#paint69_linear_3383_11459)'
        />
        <path
          d='M201.295 352.978L199.581 345.263L207.295 343.549L209.009 351.264L201.295 352.978Z'
          fill='url(#paint70_linear_3383_11459)'
        />
        <path
          d='M206.628 344.597L204.914 336.883L212.629 335.169L214.343 342.883L206.628 344.597Z'
          fill='url(#paint71_linear_3383_11459)'
        />
        <path
          d='M211.962 336.216L210.248 328.502L217.962 326.788L219.676 334.502L211.962 336.216Z'
          fill='url(#paint72_linear_3383_11459)'
        />
        <path
          d='M217.295 327.836L215.581 320.121L223.296 318.407L225.01 326.122L217.295 327.836Z'
          fill='url(#paint73_linear_3383_11459)'
        />
        <path
          d='M222.439 318.598L220.725 310.883L228.439 309.169L230.153 316.884L222.439 318.598Z'
          fill='url(#paint74_linear_3383_11459)'
        />
        <path
          d='M228.692 308.738L226.978 301.024L234.693 299.31L236.407 307.024L228.692 308.738Z'
          fill='url(#paint75_linear_3383_11459)'
        />
        <path
          d='M230.676 278.308L222.775 278.175L222.907 270.274L230.809 270.406L230.676 278.308Z'
          fill='url(#paint76_linear_3383_11459)'
        />
        <path
          d='M223.771 271.167L215.869 271.034L216.002 263.133L223.903 263.265L223.771 271.167Z'
          fill='url(#paint77_linear_3383_11459)'
        />
        <path
          d='M216.865 264.026L208.963 263.893L209.096 255.992L216.997 256.124L216.865 264.026Z'
          fill='url(#paint78_linear_3383_11459)'
        />
        <path
          d='M209.614 256.141L201.712 256.009L201.845 248.107L209.746 248.24L209.614 256.141Z'
          fill='url(#paint79_linear_3383_11459)'
        />
        <path
          d='M161.394 219.309L153.493 219.176L153.625 211.275L161.527 211.407L161.394 219.309Z'
          fill='url(#paint80_linear_3383_11459)'
        />
        <path
          d='M154.488 212.168L146.587 212.035L146.719 204.134L154.621 204.266L154.488 212.168Z'
          fill='url(#paint81_linear_3383_11459)'
        />
        <path
          d='M147.583 205.027L139.681 204.894L139.814 196.993L147.715 197.125L147.583 205.027Z'
          fill='url(#paint82_linear_3383_11459)'
        />
        <path
          d='M140.332 197.142L132.43 197.01L132.563 189.108L140.464 189.241L140.332 197.142Z'
          fill='url(#paint83_linear_3383_11459)'
        />
        <path
          d='M108.859 192.398L107.876 200.239L100.035 199.256L101.018 191.415L108.859 192.398Z'
          fill='url(#paint84_linear_3383_11459)'
        />
        <path
          d='M101.016 198.494L100.033 206.335L92.1918 205.353L93.1746 197.512L101.016 198.494Z'
          fill='url(#paint85_linear_3383_11459)'
        />
        <path
          d='M93.1722 204.591L92.1893 212.432L84.3482 211.449L85.3311 203.608L93.1722 204.591Z'
          fill='url(#paint86_linear_3383_11459)'
        />
        <path
          d='M84.5521 210.95L83.5692 218.791L75.7281 217.808L76.711 209.967L84.5521 210.95Z'
          fill='url(#paint87_linear_3383_11459)'
        />
        <path
          d='M258.934 299.46L266.74 300.69L265.511 308.496L257.704 307.266L258.934 299.46Z'
          fill='url(#paint88_linear_3383_11459)'
        />
        <path
          d='M264.78 307.492L272.586 308.722L271.356 316.528L263.55 315.298L264.78 307.492Z'
          fill='url(#paint89_linear_3383_11459)'
        />
        <path
          d='M270.626 315.524L278.432 316.753L277.202 324.56L269.396 323.33L270.626 315.524Z'
          fill='url(#paint90_linear_3383_11459)'
        />
        <path
          d='M276.71 324.34L284.516 325.57L283.287 333.376L275.48 332.146L276.71 324.34Z'
          fill='url(#paint91_linear_3383_11459)'
        />
        <path
          d='M164.439 134.012L163.456 141.853L155.615 140.87L156.598 133.029L164.439 134.012Z'
          fill='url(#paint92_linear_3383_11459)'
        />
        <path
          d='M156.595 140.108L155.612 147.949L147.771 146.967L148.754 139.126L156.595 140.108Z'
          fill='url(#paint93_linear_3383_11459)'
        />
        <path
          d='M148.752 146.205L147.769 154.046L139.928 153.063L140.91 145.222L148.752 146.205Z'
          fill='url(#paint94_linear_3383_11459)'
        />
        <path
          d='M140.131 152.564L139.149 160.405L131.307 159.422L132.29 151.581L140.131 152.564Z'
          fill='url(#paint95_linear_3383_11459)'
        />
        <path
          d='M199.627 126.804L207.452 127.909L206.347 135.734L198.522 134.629L199.627 126.804Z'
          fill='url(#paint96_linear_3383_11459)'
        />
        <path
          d='M205.6 134.742L213.425 135.847L212.32 143.672L204.495 142.567L205.6 134.742Z'
          fill='url(#paint97_linear_3383_11459)'
        />
        <path
          d='M211.573 142.68L219.398 143.785L218.293 151.609L210.468 150.504L211.573 142.68Z'
          fill='url(#paint98_linear_3383_11459)'
        />
        <path
          d='M217.798 151.398L225.622 152.503L224.517 160.328L216.693 159.223L217.798 151.398Z'
          fill='url(#paint99_linear_3383_11459)'
        />
        <path
          d='M242.627 180.142L249.974 183.053L247.064 190.399L239.717 187.489L242.627 180.142Z'
          fill='url(#paint100_linear_3383_11459)'
        />
        <path
          d='M246.571 189.26L253.918 192.17L251.007 199.517L243.66 196.607L246.571 189.26Z'
          fill='url(#paint101_linear_3383_11459)'
        />
        <path
          d='M250.514 198.378L257.861 201.288L254.95 208.635L247.603 205.724L250.514 198.378Z'
          fill='url(#paint102_linear_3383_11459)'
        />
        <path
          d='M254.518 208.313L261.865 211.224L258.954 218.571L251.607 215.66L254.518 208.313Z'
          fill='url(#paint103_linear_3383_11459)'
        />
        <path
          d='M245.519 161.872L247.166 154.143L254.895 155.79L253.248 163.519L245.519 161.872Z'
          fill='url(#paint104_linear_3383_11459)'
        />
        <path
          d='M253.853 156.466L255.499 148.737L263.228 150.383L261.582 158.112L253.853 156.466Z'
          fill='url(#paint105_linear_3383_11459)'
        />
        <path
          d='M262.187 151.059L263.833 143.33L271.562 144.977L269.916 152.706L262.187 151.059Z'
          fill='url(#paint106_linear_3383_11459)'
        />
        <path
          d='M271.317 145.456L272.963 137.727L280.692 139.374L279.046 147.103L271.317 145.456Z'
          fill='url(#paint107_linear_3383_11459)'
        />
        <path
          d='M278.239 217.376L277.361 209.523L285.214 208.644L286.093 216.498L278.239 217.376Z'
          fill='url(#paint108_linear_3383_11459)'
        />
        <path
          d='M284.439 209.614L283.561 201.761L291.414 200.883L292.293 208.736L284.439 209.614Z'
          fill='url(#paint109_linear_3383_11459)'
        />
        <path
          d='M290.639 201.853L289.761 193.999L297.614 193.121L298.493 200.974L290.639 201.853Z'
          fill='url(#paint110_linear_3383_11459)'
        />
        <path
          d='M279.015 248.879L278.524 256.766L286.411 257.257L286.902 249.369L279.015 248.879Z'
          fill='url(#paint111_linear_3383_11459)'
        />
        <path
          d='M285.59 256.326L285.099 264.213L292.986 264.704L293.477 256.816L285.59 256.326Z'
          fill='url(#paint112_linear_3383_11459)'
        />
        <path
          d='M292.164 263.773L291.674 271.66L299.561 272.151L300.052 264.263L292.164 263.773Z'
          fill='url(#paint113_linear_3383_11459)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_3383_11459'
          x1='74.4222'
          y1='276.001'
          x2='48.2203'
          y2='283.374'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3383_11459'
          x1='74.4222'
          y1='276.001'
          x2='48.2203'
          y2='283.374'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_3383_11459'
          x1='74.4222'
          y1='276.001'
          x2='48.2203'
          y2='283.374'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_3383_11459'
          x1='161.311'
          y1='308.144'
          x2='147.745'
          y2='301.538'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_3383_11459'
          x1='161.311'
          y1='308.144'
          x2='147.745'
          y2='301.538'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_3383_11459'
          x1='161.311'
          y1='308.144'
          x2='147.745'
          y2='301.538'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_3383_11459'
          x1='131.353'
          y1='398.024'
          x2='116.562'
          y2='401.005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_3383_11459'
          x1='131.353'
          y1='398.024'
          x2='116.562'
          y2='401.005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_3383_11459'
          x1='131.353'
          y1='398.024'
          x2='116.562'
          y2='401.005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_3383_11459'
          x1='197.603'
          y1='366.928'
          x2='186.287'
          y2='356.946'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_3383_11459'
          x1='197.603'
          y1='366.928'
          x2='186.287'
          y2='356.946'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_3383_11459'
          x1='197.603'
          y1='366.928'
          x2='186.287'
          y2='356.946'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_3383_11459'
          x1='297.962'
          y1='353.8'
          x2='286.647'
          y2='343.819'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_3383_11459'
          x1='297.962'
          y1='353.8'
          x2='286.647'
          y2='343.819'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_3383_11459'
          x1='297.962'
          y1='353.8'
          x2='286.647'
          y2='343.819'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint15_linear_3383_11459'
          x1='244.65'
          y1='277.947'
          x2='238.091'
          y2='294.908'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint16_linear_3383_11459'
          x1='244.65'
          y1='277.947'
          x2='238.091'
          y2='294.908'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint17_linear_3383_11459'
          x1='244.65'
          y1='277.947'
          x2='238.091'
          y2='294.908'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint18_linear_3383_11459'
          x1='121.953'
          y1='169.935'
          x2='115.394'
          y2='186.896'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint19_linear_3383_11459'
          x1='121.953'
          y1='169.935'
          x2='115.394'
          y2='186.896'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint20_linear_3383_11459'
          x1='121.953'
          y1='169.935'
          x2='115.394'
          y2='186.896'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint21_linear_3383_11459'
          x1='190.319'
          y1='110.758'
          x2='172.88'
          y2='128.224'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint22_linear_3383_11459'
          x1='190.319'
          y1='110.758'
          x2='172.88'
          y2='128.224'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint23_linear_3383_11459'
          x1='190.319'
          y1='110.758'
          x2='172.88'
          y2='128.224'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint24_linear_3383_11459'
          x1='238.905'
          y1='166.965'
          x2='226.595'
          y2='175.816'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint25_linear_3383_11459'
          x1='238.905'
          y1='166.965'
          x2='226.595'
          y2='175.816'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint26_linear_3383_11459'
          x1='238.905'
          y1='166.965'
          x2='226.595'
          y2='175.816'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint27_linear_3383_11459'
          x1='313.666'
          y1='278.158'
          x2='301.356'
          y2='287.009'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint28_linear_3383_11459'
          x1='313.666'
          y1='278.158'
          x2='301.356'
          y2='287.009'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint29_linear_3383_11459'
          x1='313.666'
          y1='278.158'
          x2='301.356'
          y2='287.009'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint30_linear_3383_11459'
          x1='313.608'
          y1='178.36'
          x2='302.536'
          y2='188.718'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint31_linear_3383_11459'
          x1='313.608'
          y1='178.36'
          x2='302.536'
          y2='188.718'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint32_linear_3383_11459'
          x1='313.608'
          y1='178.36'
          x2='302.536'
          y2='188.718'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint33_linear_3383_11459'
          x1='299.499'
          y1='124.469'
          x2='288.427'
          y2='134.827'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint34_linear_3383_11459'
          x1='299.499'
          y1='124.469'
          x2='288.427'
          y2='134.827'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint35_linear_3383_11459'
          x1='299.499'
          y1='124.469'
          x2='288.427'
          y2='134.827'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint36_linear_3383_11459'
          x1='262.122'
          y1='225.564'
          x2='271.251'
          y2='242.823'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint37_linear_3383_11459'
          x1='262.122'
          y1='225.564'
          x2='271.251'
          y2='242.823'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint38_linear_3383_11459'
          x1='262.122'
          y1='225.564'
          x2='271.251'
          y2='242.823'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint39_linear_3383_11459'
          x1='67.8579'
          y1='221.246'
          x2='63.4649'
          y2='232.606'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint40_linear_3383_11459'
          x1='67.8579'
          y1='221.246'
          x2='63.4649'
          y2='232.606'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint41_linear_3383_11459'
          x1='67.8579'
          y1='221.246'
          x2='63.4649'
          y2='232.606'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint42_linear_3383_11459'
          x1='203.603'
          y1='228.095'
          x2='170.438'
          y2='237.427'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint43_linear_3383_11459'
          x1='203.603'
          y1='228.095'
          x2='170.438'
          y2='237.427'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint44_linear_3383_11459'
          x1='203.603'
          y1='228.095'
          x2='170.438'
          y2='237.427'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint45_linear_3383_11459'
          x1='79.867'
          y1='349.891'
          x2='67.6721'
          y2='299.82'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint46_linear_3383_11459'
          x1='79.867'
          y1='349.891'
          x2='67.6721'
          y2='299.82'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint47_linear_3383_11459'
          x1='79.867'
          y1='349.891'
          x2='67.6721'
          y2='299.82'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint48_linear_3383_11459'
          x1='79.867'
          y1='349.891'
          x2='67.6721'
          y2='299.82'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint49_linear_3383_11459'
          x1='79.867'
          y1='349.891'
          x2='67.6721'
          y2='299.82'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint50_linear_3383_11459'
          x1='180.389'
          y1='257.874'
          x2='156.161'
          y2='303.359'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint51_linear_3383_11459'
          x1='180.389'
          y1='257.874'
          x2='156.161'
          y2='303.359'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint52_linear_3383_11459'
          x1='180.389'
          y1='257.874'
          x2='156.161'
          y2='303.359'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint53_linear_3383_11459'
          x1='180.389'
          y1='257.874'
          x2='156.161'
          y2='303.359'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint54_linear_3383_11459'
          x1='160.42'
          y1='316.934'
          x2='188.052'
          y2='360.434'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint55_linear_3383_11459'
          x1='160.42'
          y1='316.934'
          x2='188.052'
          y2='360.434'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint56_linear_3383_11459'
          x1='160.42'
          y1='316.934'
          x2='188.052'
          y2='360.434'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint57_linear_3383_11459'
          x1='160.42'
          y1='316.934'
          x2='188.052'
          y2='360.434'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint58_linear_3383_11459'
          x1='141.475'
          y1='393.273'
          x2='187.937'
          y2='370.977'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint59_linear_3383_11459'
          x1='141.475'
          y1='393.273'
          x2='187.937'
          y2='370.977'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint60_linear_3383_11459'
          x1='141.475'
          y1='393.273'
          x2='187.937'
          y2='370.977'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint61_linear_3383_11459'
          x1='141.475'
          y1='393.273'
          x2='187.937'
          y2='370.977'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint62_linear_3383_11459'
          x1='81.0933'
          y1='272.503'
          x2='129.648'
          y2='255.234'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint63_linear_3383_11459'
          x1='81.0933'
          y1='272.503'
          x2='129.648'
          y2='255.234'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint64_linear_3383_11459'
          x1='81.0933'
          y1='272.503'
          x2='129.648'
          y2='255.234'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint65_linear_3383_11459'
          x1='81.0933'
          y1='272.503'
          x2='129.648'
          y2='255.234'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint66_linear_3383_11459'
          x1='81.0933'
          y1='272.503'
          x2='129.648'
          y2='255.234'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint67_linear_3383_11459'
          x1='81.0933'
          y1='272.503'
          x2='129.648'
          y2='255.234'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint68_linear_3383_11459'
          x1='81.0933'
          y1='272.503'
          x2='129.648'
          y2='255.234'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint69_linear_3383_11459'
          x1='81.0933'
          y1='272.503'
          x2='129.648'
          y2='255.234'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint70_linear_3383_11459'
          x1='201.169'
          y1='352.899'
          x2='228.665'
          y2='309.312'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint71_linear_3383_11459'
          x1='201.169'
          y1='352.899'
          x2='228.665'
          y2='309.312'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint72_linear_3383_11459'
          x1='201.169'
          y1='352.899'
          x2='228.665'
          y2='309.312'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint73_linear_3383_11459'
          x1='201.169'
          y1='352.899'
          x2='228.665'
          y2='309.312'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint74_linear_3383_11459'
          x1='201.169'
          y1='352.899'
          x2='228.665'
          y2='309.312'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint75_linear_3383_11459'
          x1='201.169'
          y1='352.899'
          x2='228.665'
          y2='309.312'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint76_linear_3383_11459'
          x1='230.57'
          y1='278.412'
          x2='194.598'
          y2='241.509'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint77_linear_3383_11459'
          x1='230.57'
          y1='278.412'
          x2='194.598'
          y2='241.509'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint78_linear_3383_11459'
          x1='230.57'
          y1='278.412'
          x2='194.598'
          y2='241.509'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint79_linear_3383_11459'
          x1='230.57'
          y1='278.412'
          x2='194.598'
          y2='241.509'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint80_linear_3383_11459'
          x1='161.288'
          y1='219.413'
          x2='125.316'
          y2='182.51'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint81_linear_3383_11459'
          x1='161.288'
          y1='219.413'
          x2='125.316'
          y2='182.51'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint82_linear_3383_11459'
          x1='161.288'
          y1='219.413'
          x2='125.316'
          y2='182.51'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint83_linear_3383_11459'
          x1='161.288'
          y1='219.413'
          x2='125.316'
          y2='182.51'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint84_linear_3383_11459'
          x1='108.951'
          y1='192.515'
          x2='68.3872'
          y2='224.302'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint85_linear_3383_11459'
          x1='108.951'
          y1='192.515'
          x2='68.3872'
          y2='224.302'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint86_linear_3383_11459'
          x1='108.951'
          y1='192.515'
          x2='68.3872'
          y2='224.302'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint87_linear_3383_11459'
          x1='108.951'
          y1='192.515'
          x2='68.3872'
          y2='224.302'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint88_linear_3383_11459'
          x1='259.054'
          y1='299.372'
          x2='289.546'
          y2='340.918'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint89_linear_3383_11459'
          x1='259.054'
          y1='299.372'
          x2='289.546'
          y2='340.918'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint90_linear_3383_11459'
          x1='259.054'
          y1='299.372'
          x2='289.546'
          y2='340.918'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint91_linear_3383_11459'
          x1='259.054'
          y1='299.372'
          x2='289.546'
          y2='340.918'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint92_linear_3383_11459'
          x1='164.53'
          y1='134.129'
          x2='123.967'
          y2='165.916'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint93_linear_3383_11459'
          x1='164.53'
          y1='134.129'
          x2='123.967'
          y2='165.916'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint94_linear_3383_11459'
          x1='164.53'
          y1='134.129'
          x2='123.967'
          y2='165.916'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint95_linear_3383_11459'
          x1='164.53'
          y1='134.129'
          x2='123.967'
          y2='165.916'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint96_linear_3383_11459'
          x1='199.746'
          y1='126.714'
          x2='230.896'
          y2='167.769'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint97_linear_3383_11459'
          x1='199.746'
          y1='126.714'
          x2='230.896'
          y2='167.769'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint98_linear_3383_11459'
          x1='199.746'
          y1='126.714'
          x2='230.896'
          y2='167.769'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint99_linear_3383_11459'
          x1='199.746'
          y1='126.714'
          x2='230.896'
          y2='167.769'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint100_linear_3383_11459'
          x1='242.764'
          y1='180.082'
          x2='263.408'
          y2='227.301'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint101_linear_3383_11459'
          x1='242.764'
          y1='180.082'
          x2='263.408'
          y2='227.301'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint102_linear_3383_11459'
          x1='242.764'
          y1='180.082'
          x2='263.408'
          y2='227.301'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint103_linear_3383_11459'
          x1='242.764'
          y1='180.082'
          x2='263.408'
          y2='227.301'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint104_linear_3383_11459'
          x1='245.437'
          y1='161.748'
          x2='288.559'
          y2='133.528'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint105_linear_3383_11459'
          x1='245.437'
          y1='161.748'
          x2='288.559'
          y2='133.528'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint106_linear_3383_11459'
          x1='245.437'
          y1='161.748'
          x2='288.559'
          y2='133.528'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint107_linear_3383_11459'
          x1='245.437'
          y1='161.748'
          x2='288.559'
          y2='133.528'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint108_linear_3383_11459'
          x1='278.122'
          y1='217.284'
          x2='310.127'
          y2='176.891'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint109_linear_3383_11459'
          x1='278.122'
          y1='217.284'
          x2='310.127'
          y2='176.891'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint110_linear_3383_11459'
          x1='278.122'
          y1='217.284'
          x2='310.127'
          y2='176.891'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint111_linear_3383_11459'
          x1='278.903'
          y1='248.977'
          x2='312.857'
          y2='287.745'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint112_linear_3383_11459'
          x1='278.903'
          y1='248.977'
          x2='312.857'
          y2='287.745'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id='paint113_linear_3383_11459'
          x1='278.903'
          y1='248.977'
          x2='312.857'
          y2='287.745'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' stopOpacity='0' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <clipPath id='clip0_3383_11459'>
          <rect width='390' height='493' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
function OnboardImage1Light() {
  return (
    <svg style={{ width: '100%' }} viewBox='0 0 390 493' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3383_11434)'>
        <g opacity='0.6'>
          <rect
            opacity='0.5'
            x='178.417'
            y='74.5273'
            width='52.0273'
            height='52.0273'
            stroke='#010101'
            strokeOpacity='0.05'
          />
          <rect
            opacity='0.5'
            x='284.032'
            y='21.5'
            width='52.0273'
            height='52.0273'
            stroke='#010101'
            strokeOpacity='0.05'
          />
          <rect
            opacity='0.5'
            x='284.032'
            y='127.555'
            width='52.0273'
            height='52.0273'
            stroke='#010101'
            strokeOpacity='0.05'
          />
          <g opacity='0.5'>
            <mask id='path-4-inside-1_3383_11434' fill='white'>
              <path d='M336.558 127.055H389.585V180.082H336.558V127.055Z' />
            </mask>
            <path
              d='M389.585 127.055H390.585V126.055H389.585V127.055ZM389.585 180.082V181.082H390.585V180.082H389.585ZM336.558 128.055H389.585V126.055H336.558V128.055ZM388.585 127.055V180.082H390.585V127.055H388.585ZM389.585 179.082H336.558V181.082H389.585V179.082Z'
              fill='#010101'
              fillOpacity='0.05'
              mask='url(#path-4-inside-1_3383_11434)'
            />
          </g>
          <rect
            opacity='0.5'
            x='125.5'
            y='180.503'
            width='52.0273'
            height='52.0273'
            stroke='#010101'
            strokeOpacity='0.05'
          />
          <mask id='path-7-inside-2_3383_11434' fill='white'>
            <path d='M230.946 74.0273H283.973V127.055H230.946V74.0273Z' />
          </mask>
          <path
            d='M230.946 127.055H229.946V128.055H230.946V127.055ZM283.973 126.055H230.946V128.055H283.973V126.055ZM231.946 127.055V74.0273H229.946V127.055H231.946Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-7-inside-2_3383_11434)'
          />
          <mask id='path-9-inside-3_3383_11434' fill='white'>
            <path d='M230.946 127.055H283.973V180.082H230.946V127.055Z' />
          </mask>
          <path
            d='M283.973 179.082H230.946V181.082H283.973V179.082Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-9-inside-3_3383_11434)'
          />
          <mask id='path-11-inside-4_3383_11434' fill='white'>
            <path d='M336.558 74.0273L336.558 127.055L283.531 127.055L283.531 74.0273L336.558 74.0273Z' />
          </mask>
          <path
            d='M335.558 74.0273L335.558 127.055L337.558 127.055L337.558 74.0273L335.558 74.0273ZM284.531 127.055L284.531 74.0273L282.531 74.0273L282.531 127.055L284.531 127.055Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-11-inside-4_3383_11434)'
          />
          <mask id='path-13-inside-5_3383_11434' fill='white'>
            <path d='M177.917 127.055H230.945V180.082H177.917V127.055Z' />
          </mask>
          <path
            d='M230.945 180.082V181.082H231.945V180.082H230.945ZM177.917 180.082H176.917V181.082H177.917V180.082ZM229.945 127.055V180.082H231.945V127.055H229.945ZM230.945 179.082H177.917V181.082H230.945V179.082ZM178.917 180.082V127.055H176.917V180.082H178.917Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-13-inside-5_3383_11434)'
          />
          <mask id='path-15-inside-6_3383_11434' fill='white'>
            <path d='M283.532 180.082H336.559V233.109H283.532V180.082Z' />
          </mask>
          <path
            d='M336.559 233.109V234.109H337.559V233.109H336.559ZM335.559 180.082V233.109H337.559V180.082H335.559ZM336.559 232.109H283.532V234.109H336.559V232.109Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-15-inside-6_3383_11434)'
          />
          <mask id='path-17-inside-7_3383_11434' fill='white'>
            <path d='M177.917 180.082H230.945V233.109H177.917V180.082Z' />
          </mask>
          <path
            d='M230.945 233.109V234.109H231.945V233.109H230.945ZM229.945 180.082V233.109H231.945V180.082H229.945ZM230.945 232.109H177.917V234.109H230.945V232.109Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-17-inside-7_3383_11434)'
          />
          <rect
            x='283.032'
            y='21.5'
            width='52.0273'
            height='52.0273'
            transform='rotate(90 283.032 21.5)'
            stroke='#010101'
            strokeOpacity='0.05'
          />
          <mask id='path-20-inside-8_3383_11434' fill='white'>
            <path d='M389.585 21L389.585 74.0273L336.558 74.0273L336.558 21L389.585 21Z' />
          </mask>
          <path
            d='M389.585 21L390.585 21L390.585 20L389.585 20L389.585 21ZM389.585 74.0273L389.585 75.0273L390.585 75.0273L390.585 74.0273L389.585 74.0273ZM388.585 21L388.585 74.0273L390.585 74.0273L390.585 21L388.585 21ZM389.585 73.0273L336.558 73.0273L336.558 75.0273L389.585 75.0273L389.585 73.0273ZM336.558 22L389.585 22L389.585 20L336.558 20L336.558 22Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-20-inside-8_3383_11434)'
          />
        </g>
        <g opacity='0.6'>
          <rect
            opacity='0.5'
            x='211.168'
            y='417.582'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 211.168 417.582)'
            stroke='#010101'
            strokeOpacity='0.05'
          />
          <rect
            opacity='0.5'
            x='105.553'
            y='470.609'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 105.553 470.609)'
            stroke='#010101'
            strokeOpacity='0.05'
          />
          <rect
            opacity='0.5'
            x='105.553'
            y='364.555'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 105.553 364.555)'
            stroke='#010101'
            strokeOpacity='0.05'
          />
          <g opacity='0.5'>
            <mask id='path-25-inside-9_3383_11434' fill='white'>
              <path d='M53.0272 365.055H-3.8147e-05V312.027H53.0272V365.055Z' />
            </mask>
            <path
              d='M-3.8147e-05 365.055H-1.00004V366.055H-3.8147e-05V365.055ZM-3.8147e-05 312.027V311.027H-1.00004V312.027H-3.8147e-05ZM53.0272 364.055H-3.8147e-05V366.055H53.0272V364.055ZM0.999962 365.055V312.027H-1.00004V365.055H0.999962ZM-3.8147e-05 313.027H53.0272V311.027H-3.8147e-05V313.027Z'
              fill='#010101'
              fillOpacity='0.05'
              mask='url(#path-25-inside-9_3383_11434)'
            />
          </g>
          <rect
            opacity='0.5'
            x='264.085'
            y='311.605'
            width='52.0273'
            height='52.0273'
            transform='rotate(180 264.085 311.605)'
            stroke='#010101'
            strokeOpacity='0.05'
          />
          <mask id='path-28-inside-10_3383_11434' fill='white'>
            <path d='M158.639 418.082H105.612V365.054H158.639V418.082Z' />
          </mask>
          <path
            d='M158.639 365.054H159.639V364.054H158.639V365.054ZM105.612 366.054H158.639V364.054H105.612V366.054ZM157.639 365.054V418.082H159.639V365.054H157.639Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-28-inside-10_3383_11434)'
          />
          <mask id='path-30-inside-11_3383_11434' fill='white'>
            <path d='M158.639 365.055H105.612V312.027H158.639V365.055Z' />
          </mask>
          <path
            d='M105.612 313.027H158.639V311.027H105.612V313.027Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-30-inside-11_3383_11434)'
          />
          <mask id='path-32-inside-12_3383_11434' fill='white'>
            <path d='M53.0272 418.082L53.0272 365.054L106.054 365.054L106.054 418.082L53.0272 418.082Z' />
          </mask>
          <path
            d='M54.0272 418.082L54.0272 365.054L52.0272 365.054L52.0272 418.082L54.0272 418.082ZM105.054 365.054L105.054 418.082L107.054 418.082L107.054 365.054L105.054 365.054Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-32-inside-12_3383_11434)'
          />
          <mask id='path-34-inside-13_3383_11434' fill='white'>
            <path d='M211.668 365.055H158.64V312.027H211.668V365.055Z' />
          </mask>
          <path
            d='M158.64 312.027V311.027H157.64V312.027H158.64ZM211.668 312.027H212.668V311.027H211.668V312.027ZM159.64 365.055V312.027H157.64V365.055H159.64ZM158.64 313.027H211.668V311.027H158.64V313.027ZM210.668 312.027V365.055H212.668V312.027H210.668Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-34-inside-13_3383_11434)'
          />
          <mask id='path-36-inside-14_3383_11434' fill='white'>
            <path d='M106.053 312.027H53.026V259H106.053V312.027Z' />
          </mask>
          <path
            d='M53.026 259V258H52.026V259H53.026ZM54.026 312.027V259H52.026V312.027H54.026ZM53.026 260H106.053V258H53.026V260Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-36-inside-14_3383_11434)'
          />
          <mask id='path-38-inside-15_3383_11434' fill='white'>
            <path d='M211.668 312.027H158.64V259H211.668V312.027Z' />
          </mask>
          <path
            d='M158.64 259V258H157.64V259H158.64ZM159.64 312.027V259H157.64V312.027H159.64ZM158.64 260H211.668V258H158.64V260Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-38-inside-15_3383_11434)'
          />
          <rect
            x='106.553'
            y='470.609'
            width='52.0273'
            height='52.0273'
            transform='rotate(-90 106.553 470.609)'
            stroke='#010101'
            strokeOpacity='0.05'
          />
          <mask id='path-41-inside-16_3383_11434' fill='white'>
            <path d='M0 471.109L2.3179e-06 418.082L53.0273 418.082L53.0273 471.109L0 471.109Z' />
          </mask>
          <path
            d='M0 471.109L-1 471.109L-1 472.109L-4.37114e-08 472.109L0 471.109ZM2.3179e-06 418.082L2.36161e-06 417.082L-0.999998 417.082L-0.999998 418.082L2.3179e-06 418.082ZM1 471.109L1 418.082L-0.999998 418.082L-1 471.109L1 471.109ZM2.27418e-06 419.082L53.0273 419.082L53.0273 417.082L2.36161e-06 417.082L2.27418e-06 419.082ZM53.0273 470.109L4.37114e-08 470.109L-4.37114e-08 472.109L53.0273 472.109L53.0273 470.109Z'
            fill='#010101'
            fillOpacity='0.05'
            mask='url(#path-41-inside-16_3383_11434)'
          />
        </g>
        <path
          d='M73.8826 291.291L56.9782 296.048L49.6051 269.846L66.5095 265.089L73.8826 291.291Z'
          fill='url(#paint0_linear_3383_11434)'
        />
        <path
          d='M50.4798 292.403L45.9608 276.344L51.0321 274.917L55.5511 290.976L50.4798 292.403Z'
          fill='url(#paint1_linear_3383_11434)'
        />
        <path
          d='M71.6104 286.457L67.0914 270.398L72.1627 268.971L76.6817 285.03L71.6104 286.457Z'
          fill='url(#paint2_linear_3383_11434)'
        />
        <rect
          x='46.4916'
          y='294.438'
          width='17.561'
          height='4.39024'
          transform='rotate(-105.716 46.4916 294.438)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='66.5096'
          y='265.088'
          width='17.561'
          height='4.39024'
          transform='rotate(164.284 66.5096 265.088)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='75.0719'
          y='295.517'
          width='17.561'
          height='4.39024'
          transform='rotate(164.284 75.0719 295.517)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='56.9783'
          y='296.047'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 56.9783 296.047)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='51.0322'
          y='274.917'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 51.0322 274.917)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='78.954'
          y='289.863'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 78.954 289.863)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='73.0079'
          y='268.733'
          width='5.26829'
          height='5.26829'
          transform='rotate(164.284 73.0079 268.733)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='76.9196'
          y='285.875'
          width='17.561'
          height='4.39024'
          transform='rotate(-105.716 76.9196 285.875)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M155.82 314.862L147.068 310.6L153.673 297.034L162.426 301.296L155.82 314.862Z'
          fill='url(#paint3_linear_3383_11434)'
        />
        <path
          d='M145.721 306.696L149.769 298.381L152.395 299.66L148.346 307.974L145.721 306.696Z'
          fill='url(#paint4_linear_3383_11434)'
        />
        <path
          d='M156.661 312.023L160.709 303.708L163.335 304.987L159.286 313.301L156.661 312.023Z'
          fill='url(#paint5_linear_3383_11434)'
        />
        <rect
          x='143.319'
          y='306.068'
          width='9.73465'
          height='2.43366'
          transform='rotate(-64.0372 143.319 306.068)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='162.426'
          y='301.295'
          width='9.73465'
          height='2.43366'
          transform='rotate(-154.037 162.426 301.295)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='154.754'
          y='317.049'
          width='9.73465'
          height='2.43366'
          transform='rotate(-154.037 154.754 317.049)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='147.068'
          y='310.6'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 147.068 310.6)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='152.395'
          y='299.66'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 152.395 299.66)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='158.446'
          y='316.14'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 158.446 316.14)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='163.773'
          y='305.2'
          width='2.92039'
          height='2.92039'
          transform='rotate(-154.037 163.773 305.2)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='159.073'
          y='313.739'
          width='9.73465'
          height='2.43366'
          transform='rotate(-64.0372 159.073 313.739)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M130.458 406.901L120.915 408.824L117.934 394.032L127.477 392.109L130.458 406.901Z'
          fill='url(#paint6_linear_3383_11434)'
        />
        <path
          d='M117.475 406.538L115.648 397.472L118.511 396.895L120.338 405.961L117.475 406.538Z'
          fill='url(#paint7_linear_3383_11434)'
        />
        <path
          d='M129.404 404.134L127.577 395.068L130.44 394.491L132.267 403.557L129.404 404.134Z'
          fill='url(#paint8_linear_3383_11434)'
        />
        <rect
          x='115.186'
          y='407.495'
          width='9.73465'
          height='2.43366'
          transform='rotate(-101.393 115.186 407.495)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='127.477'
          y='392.109'
          width='9.73465'
          height='2.43366'
          transform='rotate(168.607 127.477 392.109)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='130.938'
          y='409.286'
          width='9.73465'
          height='2.43366'
          transform='rotate(168.607 130.938 409.286)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='120.915'
          y='408.823'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 120.915 408.823)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='118.511'
          y='396.895'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 118.511 396.895)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='133.321'
          y='406.324'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 133.321 406.324)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='130.917'
          y='394.395'
          width='2.92039'
          height='2.92039'
          transform='rotate(168.607 130.917 394.395)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='132.363'
          y='404.034'
          width='9.73465'
          height='2.43366'
          transform='rotate(-101.393 132.363 404.034)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M190.787 371.975L183.487 365.536L193.468 354.22L200.768 360.66L190.787 371.975Z'
          fill='url(#paint9_linear_3383_11434)'
        />
        <path
          d='M183.228 361.414L189.346 354.478L191.536 356.41L185.418 363.346L183.228 361.414Z'
          fill='url(#paint10_linear_3383_11434)'
        />
        <path
          d='M192.354 369.463L198.471 362.528L200.662 364.46L194.544 371.395L192.354 369.463Z'
          fill='url(#paint11_linear_3383_11434)'
        />
        <rect
          x='181.081'
          y='360.169'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 181.081 360.169)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='200.768'
          y='360.66'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 200.768 360.66)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='189.177'
          y='373.801'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 189.177 373.801)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='183.487'
          y='365.536'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 183.487 365.536)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='191.536'
          y='356.41'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 191.536 356.41)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='192.977'
          y='373.907'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 192.977 373.907)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='201.026'
          y='364.782'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 201.026 364.782)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='194.222'
          y='371.76'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 194.222 371.76)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M291.147 358.848L283.846 352.409L293.827 341.093L301.128 347.533L291.147 358.848Z'
          fill='url(#paint12_linear_3383_11434)'
        />
        <path
          d='M283.588 348.287L289.705 341.351L291.896 343.283L285.778 350.219L283.588 348.287Z'
          fill='url(#paint13_linear_3383_11434)'
        />
        <path
          d='M292.714 356.336L298.831 349.401L301.021 351.333L294.904 358.268L292.714 356.336Z'
          fill='url(#paint14_linear_3383_11434)'
        />
        <rect
          x='281.441'
          y='347.042'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 281.441 347.042)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='301.128'
          y='347.533'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 301.128 347.533)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='289.537'
          y='360.674'
          width='9.73465'
          height='2.43366'
          transform='rotate(-138.586 289.537 360.674)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='283.846'
          y='352.409'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 283.846 352.409)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='291.896'
          y='343.283'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 291.896 343.283)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='293.337'
          y='360.78'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 293.337 360.78)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='301.386'
          y='351.655'
          width='2.92039'
          height='2.92039'
          transform='rotate(-138.586 301.386 351.655)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='294.582'
          y='358.633'
          width='9.73465'
          height='2.43366'
          transform='rotate(-48.5858 294.582 358.633)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M252.072 284.962L247.841 295.905L230.88 289.346L235.111 278.403L252.072 284.962Z'
          fill='url(#paint15_linear_3383_11434)'
        />
        <path
          d='M243.289 297.918L232.893 293.898L234.163 290.615L244.558 294.635L243.289 297.918Z'
          fill='url(#paint16_linear_3383_11434)'
        />
        <path
          d='M248.578 284.24L238.183 280.22L239.452 276.937L249.848 280.957L248.578 284.24Z'
          fill='url(#paint17_linear_3383_11434)'
        />
        <rect
          x='242.778'
          y='300.865'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 242.778 300.865)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='235.111'
          y='278.403'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 235.111 278.403)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='254.808'
          y='286.02'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 254.808 286.02)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='247.841'
          y='295.904'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 247.841 295.904)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='234.163'
          y='290.615'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 234.163 290.615)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='253.342'
          y='281.68'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 253.342 281.68)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='239.664'
          y='276.39'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 239.664 276.39)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='250.395'
          y='281.168'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 250.395 281.168)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M129.376 176.95L125.144 187.893L108.183 181.334L112.415 170.392L129.376 176.95Z'
          fill='url(#paint18_linear_3383_11434)'
        />
        <path
          d='M120.592 189.906L110.197 185.886L111.466 182.604L121.862 186.624L120.592 189.906Z'
          fill='url(#paint19_linear_3383_11434)'
        />
        <path
          d='M125.882 176.228L115.486 172.208L116.756 168.925L127.151 172.945L125.882 176.228Z'
          fill='url(#paint20_linear_3383_11434)'
        />
        <rect
          x='120.081'
          y='192.854'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 120.081 192.854)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='112.415'
          y='170.392'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 112.415 170.392)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='132.111'
          y='178.008'
          width='11.7322'
          height='2.93306'
          transform='rotate(111.142 132.111 178.008)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='125.144'
          y='187.893'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 125.144 187.893)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='111.466'
          y='182.604'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 111.466 182.604)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='130.645'
          y='173.668'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 130.645 173.668)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='116.967'
          y='168.378'
          width='3.51967'
          height='3.51967'
          transform='rotate(111.142 116.967 168.378)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='127.698'
          y='173.157'
          width='11.7322'
          height='2.93306'
          transform='rotate(-158.858 127.698 173.157)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M196.239 123.295L184.988 134.563L167.522 117.124L178.773 105.856L196.239 123.295Z'
          fill='url(#paint21_linear_3383_11434)'
        />
        <path
          d='M178.232 134.568L167.528 123.88L170.903 120.499L181.608 131.188L178.232 134.568Z'
          fill='url(#paint22_linear_3383_11434)'
        />
        <path
          d='M192.296 120.483L181.591 109.795L184.967 106.414L195.671 117.102L192.296 120.483Z'
          fill='url(#paint23_linear_3383_11434)'
        />
        <rect
          x='175.983'
          y='137.948'
          width='15.9234'
          height='3.98084'
          transform='rotate(-135.044 175.983 137.948)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='178.773'
          y='105.856'
          width='15.9234'
          height='3.98084'
          transform='rotate(134.956 178.773 105.856)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='199.056'
          y='126.108'
          width='15.9234'
          height='3.98084'
          transform='rotate(134.956 199.056 126.108)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='184.988'
          y='134.563'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 184.988 134.563)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='170.903'
          y='120.5'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 170.903 120.5)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='199.614'
          y='119.915'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 199.614 119.915)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='185.529'
          y='105.851'
          width='4.77701'
          height='4.77701'
          transform='rotate(134.956 185.529 105.851)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='196.235'
          y='117.665'
          width='15.9234'
          height='3.98084'
          transform='rotate(-135.044 196.235 117.665)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M241.345 175.547L233.403 181.258L224.552 168.948L232.494 163.238L241.345 175.547Z'
          fill='url(#paint24_linear_3383_11434)'
        />
        <path
          d='M229.307 180.588L223.883 173.043L226.265 171.33L231.69 178.875L229.307 180.588Z'
          fill='url(#paint25_linear_3383_11434)'
        />
        <path
          d='M239.235 173.45L233.81 165.906L236.193 164.193L241.617 171.737L239.235 173.45Z'
          fill='url(#paint26_linear_3383_11434)'
        />
        <rect
          x='227.607'
          y='182.413'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 227.607 182.413)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='232.494'
          y='163.238'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 232.494 163.238)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='242.772'
          y='177.533'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 242.772 177.533)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='233.403'
          y='181.258'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 233.403 181.258)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='226.265'
          y='171.331'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 226.265 171.331)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='243.727'
          y='173.834'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 243.727 173.834)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='236.59'
          y='163.907'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 236.59 163.907)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='241.903'
          y='172.134'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 241.903 172.134)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M316.105 286.74L308.164 292.451L299.313 280.141L307.255 274.43L316.105 286.74Z'
          fill='url(#paint27_linear_3383_11434)'
        />
        <path
          d='M304.068 291.781L298.643 284.236L301.026 282.523L306.451 290.068L304.068 291.781Z'
          fill='url(#paint28_linear_3383_11434)'
        />
        <path
          d='M313.995 284.643L308.571 277.099L310.953 275.385L316.378 282.93L313.995 284.643Z'
          fill='url(#paint29_linear_3383_11434)'
        />
        <rect
          x='302.368'
          y='293.605'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 302.368 293.605)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='307.255'
          y='274.431'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 307.255 274.431)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='317.533'
          y='288.726'
          width='9.78159'
          height='2.4454'
          transform='rotate(144.284 317.533 288.726)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='308.163'
          y='292.451'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 308.163 292.451)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='301.026'
          y='282.523'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 301.026 282.523)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='318.488'
          y='285.027'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 318.488 285.027)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='311.35'
          y='275.1'
          width='2.93448'
          height='2.93448'
          transform='rotate(144.284 311.35 275.1)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='316.663'
          y='283.327'
          width='9.78159'
          height='2.4454'
          transform='rotate(-125.716 316.663 283.327)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M317.001 186.567L309.858 193.249L299.5 182.177L306.644 175.495L317.001 186.567Z'
          fill='url(#paint30_linear_3383_11434)'
        />
        <path
          d='M305.71 193.111L299.362 186.325L301.505 184.32L307.853 191.106L305.71 193.111Z'
          fill='url(#paint31_linear_3383_11434)'
        />
        <path
          d='M314.639 184.758L308.291 177.972L310.434 175.967L316.782 182.753L314.639 184.758Z'
          fill='url(#paint32_linear_3383_11434)'
        />
        <rect
          x='304.259'
          y='195.139'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 304.259 195.139)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='306.644'
          y='175.495'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 306.644 175.495)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='318.672'
          y='188.353'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 318.672 188.353)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='309.858'
          y='193.25'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 309.858 193.25)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='301.505'
          y='184.32'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 301.505 184.32)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='319.144'
          y='184.562'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 319.144 184.562)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='310.791'
          y='175.633'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 310.791 175.633)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='317.116'
          y='183.11'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 317.116 183.11)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M302.892 132.676L295.749 139.358L285.392 128.286L292.535 121.604L302.892 132.676Z'
          fill='url(#paint33_linear_3383_11434)'
        />
        <path
          d='M291.602 139.22L285.253 132.434L287.396 130.429L293.745 137.215L291.602 139.22Z'
          fill='url(#paint34_linear_3383_11434)'
        />
        <path
          d='M300.531 130.867L294.182 124.081L296.325 122.076L302.674 128.862L300.531 130.867Z'
          fill='url(#paint35_linear_3383_11434)'
        />
        <rect
          x='290.15'
          y='141.248'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 290.15 141.248)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='292.535'
          y='121.604'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 292.535 121.604)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='304.563'
          y='134.462'
          width='9.78159'
          height='2.4454'
          transform='rotate(136.909 304.563 134.462)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='295.749'
          y='139.358'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 295.749 139.358)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='287.396'
          y='130.429'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 287.396 130.429)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='305.035'
          y='130.671'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 305.035 130.671)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='296.682'
          y='121.742'
          width='2.93448'
          height='2.93448'
          transform='rotate(136.909 296.682 121.742)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='303.008'
          y='129.219'
          width='9.78159'
          height='2.4454'
          transform='rotate(-133.091 303.008 129.219)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M272.223 224.784L278.113 235.918L260.854 245.047L254.965 233.913L272.223 224.784Z'
          fill='url(#paint36_linear_3383_11434)'
        />
        <path
          d='M276.54 241.026L265.962 246.621L264.195 243.28L274.773 237.685L276.54 241.026Z'
          fill='url(#paint37_linear_3383_11434)'
        />
        <path
          d='M269.178 227.107L258.6 232.702L256.833 229.362L267.411 223.767L269.178 227.107Z'
          fill='url(#paint38_linear_3383_11434)'
        />
        <rect
          x='278.569'
          y='243.515'
          width='12.5964'
          height='3.14911'
          transform='rotate(152.124 278.569 243.515)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='254.965'
          y='233.913'
          width='12.5964'
          height='3.14911'
          transform='rotate(62.1237 254.965 233.913)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='275.007'
          y='223.312'
          width='12.5964'
          height='3.14911'
          transform='rotate(62.1237 275.007 223.312)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='278.113'
          y='235.918'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 278.113 235.918)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='264.195'
          y='243.281'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 264.195 243.281)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='270.457'
          y='221.443'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 270.457 221.443)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='256.539'
          y='228.806'
          width='3.77893'
          height='3.77893'
          transform='rotate(62.1237 256.539 228.806)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='267.967'
          y='223.473'
          width='12.5964'
          height='3.14911'
          transform='rotate(152.124 267.967 223.473)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M72.8293 226.275L69.9951 233.604L58.6352 229.211L61.4694 221.882L72.8293 226.275Z'
          fill='url(#paint39_linear_3383_11434)'
        />
        <path
          d='M66.9462 234.952L59.9837 232.26L60.8339 230.061L67.7964 232.754L66.9462 234.952Z'
          fill='url(#paint40_linear_3383_11434)'
        />
        <path
          d='M70.4889 225.791L63.5263 223.099L64.3766 220.9L71.3391 223.593L70.4889 225.791Z'
          fill='url(#paint41_linear_3383_11434)'
        />
        <rect
          x='66.6041'
          y='236.926'
          width='7.85789'
          height='1.96447'
          transform='rotate(-158.858 66.6041 236.926)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='61.4694'
          y='221.882'
          width='7.85789'
          height='1.96447'
          transform='rotate(111.142 61.4694 221.882)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='74.6615'
          y='226.983'
          width='7.85789'
          height='1.96447'
          transform='rotate(111.142 74.6615 226.983)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='69.995'
          y='233.604'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 69.995 233.604)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='60.834'
          y='230.061'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 60.834 230.061)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='73.6796'
          y='224.076'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 73.6796 224.076)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='64.5184'
          y='220.534'
          width='2.35737'
          height='2.35737'
          transform='rotate(111.142 64.5184 220.534)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='71.7056'
          y='223.734'
          width='7.85789'
          height='1.96447'
          transform='rotate(-158.858 71.7056 223.734)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M202.92 247.183L181.524 253.203L172.191 220.039L193.588 214.018L202.92 247.183Z'
          fill='url(#paint42_linear_3383_11434)'
        />
        <path
          d='M173.298 248.591L167.578 228.264L173.997 226.458L179.717 246.785L173.298 248.591Z'
          fill='url(#paint43_linear_3383_11434)'
        />
        <path
          d='M200.044 241.065L194.324 220.738L200.743 218.932L206.463 239.258L200.044 241.065Z'
          fill='url(#paint44_linear_3383_11434)'
        />
        <rect
          x='168.25'
          y='251.166'
          width='22.2276'
          height='5.55689'
          transform='rotate(-105.716 168.25 251.166)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='193.588'
          y='214.018'
          width='22.2276'
          height='5.55689'
          transform='rotate(164.284 193.588 214.018)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='204.425'
          y='252.532'
          width='22.2276'
          height='5.55689'
          transform='rotate(164.284 204.425 252.532)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='181.524'
          y='253.204'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 181.524 253.204)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='173.997'
          y='226.458'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 173.997 226.458)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='209.339'
          y='245.376'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 209.339 245.376)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='201.813'
          y='218.631'
          width='6.66827'
          height='6.66827'
          transform='rotate(164.284 201.813 218.631)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='206.764'
          y='240.329'
          width='22.2276'
          height='5.55689'
          transform='rotate(-105.716 206.764 240.329)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='62.9459'
          y='382.787'
          width='17.561'
          height='4.39024'
          transform='rotate(-91.4108 62.9459 382.787)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='89.5951'
          y='359.294'
          width='17.561'
          height='4.39024'
          transform='rotate(178.589 89.5951 359.294)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='90.3734'
          y='390.895'
          width='17.561'
          height='4.39024'
          transform='rotate(178.589 90.3734 390.895)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='72.7096'
          y='386.938'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 72.7096 386.938)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='72.1692'
          y='364.994'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 72.1692 364.994)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='95.532'
          y='386.376'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 95.532 386.376)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='94.9915'
          y='364.432'
          width='5.26829'
          height='5.26829'
          transform='rotate(178.589 94.9915 364.432)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <rect
          x='94.5461'
          y='382.009'
          width='17.561'
          height='4.39024'
          transform='rotate(-91.4108 94.5461 382.009)'
          fill='#391998'
          fillOpacity='0.8'
        />
        <path
          d='M80.0117 350.856L73.2766 346.723L77.4103 339.987L84.1453 344.121L80.0117 350.856Z'
          fill='url(#paint45_linear_3383_11434)'
        />
        <path
          d='M77.6993 341.195L70.9642 337.061L75.0979 330.326L81.833 334.46L77.6993 341.195Z'
          fill='url(#paint46_linear_3383_11434)'
        />
        <path
          d='M75.3869 331.534L68.6519 327.4L72.7855 320.665L79.5206 324.799L75.3869 331.534Z'
          fill='url(#paint47_linear_3383_11434)'
        />
        <path
          d='M73.0746 321.873L66.3395 317.739L70.4732 311.004L77.2082 315.138L73.0746 321.873Z'
          fill='url(#paint48_linear_3383_11434)'
        />
        <path
          d='M70.0139 311.752L63.2788 307.619L67.4125 300.884L74.1475 305.017L70.0139 311.752Z'
          fill='url(#paint49_linear_3383_11434)'
        />
        <path
          d='M180.258 258.804L182.532 266.372L174.964 268.647L172.69 261.079L180.258 258.804Z'
          fill='url(#paint50_linear_3383_11434)'
        />
        <path
          d='M175.553 267.553L177.827 275.121L170.259 277.396L167.985 269.828L175.553 267.553Z'
          fill='url(#paint51_linear_3383_11434)'
        />
        <path
          d='M170.847 276.302L173.122 283.87L165.554 286.145L163.28 278.577L170.847 276.302Z'
          fill='url(#paint52_linear_3383_11434)'
        />
        <path
          d='M165.554 286.145L167.829 293.713L160.261 295.988L157.986 288.42L165.554 286.145Z'
          fill='url(#paint53_linear_3383_11434)'
        />
        <path
          d='M160.294 318.014L168 319.765L166.249 327.471L158.543 325.719L160.294 318.014Z'
          fill='url(#paint54_linear_3383_11434)'
        />
        <path
          d='M165.587 326.42L173.293 328.171L171.542 335.877L163.836 334.126L165.587 326.42Z'
          fill='url(#paint55_linear_3383_11434)'
        />
        <path
          d='M170.881 334.826L178.586 336.577L176.835 344.283L169.129 342.532L170.881 334.826Z'
          fill='url(#paint56_linear_3383_11434)'
        />
        <path
          d='M176.835 344.283L184.541 346.035L182.79 353.741L175.084 351.989L176.835 344.283Z'
          fill='url(#paint57_linear_3383_11434)'
        />
        <path
          d='M141.539 394.407L144.189 386.963L151.634 389.613L148.984 397.057L141.539 394.407Z'
          fill='url(#paint58_linear_3383_11434)'
        />
        <path
          d='M150.513 390.145L153.163 382.7L160.607 385.35L157.958 392.795L150.513 390.145Z'
          fill='url(#paint59_linear_3383_11434)'
        />
        <path
          d='M159.486 385.883L162.136 378.438L169.581 381.088L166.931 388.533L159.486 385.883Z'
          fill='url(#paint60_linear_3383_11434)'
        />
        <path
          d='M169.581 381.088L172.231 373.643L179.676 376.293L177.026 383.738L169.581 381.088Z'
          fill='url(#paint61_linear_3383_11434)'
        />
        <path
          d='M81.1432 273.644L84.5639 266.52L91.6876 269.941L88.267 277.064L81.1432 273.644Z'
          fill='url(#paint62_linear_3383_11434)'
        />
        <path
          d='M90.516 270.352L93.9367 263.228L101.06 266.649L97.6398 273.773L90.516 270.352Z'
          fill='url(#paint63_linear_3383_11434)'
        />
        <path
          d='M99.8888 267.06L103.31 259.937L110.433 263.357L107.013 270.481L99.8888 267.06Z'
          fill='url(#paint64_linear_3383_11434)'
        />
        <path
          d='M109.262 263.769L112.682 256.645L119.806 260.066L116.385 267.189L109.262 263.769Z'
          fill='url(#paint65_linear_3383_11434)'
        />
        <path
          d='M119.015 259.686L122.435 252.562L129.559 255.983L126.138 263.106L119.015 259.686Z'
          fill='url(#paint66_linear_3383_11434)'
        />
        <path
          d='M129.559 255.983L132.98 248.859L140.103 252.28L136.683 259.403L129.559 255.983Z'
          fill='url(#paint67_linear_3383_11434)'
        />
        <path
          d='M140.62 252.114L144.041 244.991L151.164 248.411L147.744 255.535L140.62 252.114Z'
          fill='url(#paint68_linear_3383_11434)'
        />
        <path
          d='M151.164 248.411L154.585 241.287L161.709 244.708L158.288 251.832L151.164 248.411Z'
          fill='url(#paint69_linear_3383_11434)'
        />
        <path
          d='M201.295 353.977L199.581 346.263L207.295 344.549L209.009 352.263L201.295 353.977Z'
          fill='url(#paint70_linear_3383_11434)'
        />
        <path
          d='M206.628 345.597L204.914 337.882L212.629 336.168L214.343 343.883L206.628 345.597Z'
          fill='url(#paint71_linear_3383_11434)'
        />
        <path
          d='M211.962 337.216L210.248 329.502L217.962 327.788L219.676 335.502L211.962 337.216Z'
          fill='url(#paint72_linear_3383_11434)'
        />
        <path
          d='M217.295 328.835L215.581 321.121L223.296 319.407L225.01 327.121L217.295 328.835Z'
          fill='url(#paint73_linear_3383_11434)'
        />
        <path
          d='M222.439 319.597L220.725 311.883L228.439 310.169L230.153 317.883L222.439 319.597Z'
          fill='url(#paint74_linear_3383_11434)'
        />
        <path
          d='M228.692 309.738L226.978 302.024L234.693 300.31L236.407 308.024L228.692 309.738Z'
          fill='url(#paint75_linear_3383_11434)'
        />
        <path
          d='M230.676 279.307L222.775 279.175L222.907 271.274L230.809 271.406L230.676 279.307Z'
          fill='url(#paint76_linear_3383_11434)'
        />
        <path
          d='M223.771 272.166L215.869 272.034L216.002 264.133L223.903 264.265L223.771 272.166Z'
          fill='url(#paint77_linear_3383_11434)'
        />
        <path
          d='M216.865 265.025L208.963 264.893L209.096 256.992L216.997 257.124L216.865 265.025Z'
          fill='url(#paint78_linear_3383_11434)'
        />
        <path
          d='M209.614 257.141L201.712 257.008L201.845 249.107L209.746 249.239L209.614 257.141Z'
          fill='url(#paint79_linear_3383_11434)'
        />
        <path
          d='M161.394 220.309L153.493 220.177L153.625 212.275L161.527 212.408L161.394 220.309Z'
          fill='url(#paint80_linear_3383_11434)'
        />
        <path
          d='M154.488 213.168L146.587 213.036L146.719 205.134L154.621 205.267L154.488 213.168Z'
          fill='url(#paint81_linear_3383_11434)'
        />
        <path
          d='M147.583 206.027L139.681 205.895L139.814 197.993L147.715 198.126L147.583 206.027Z'
          fill='url(#paint82_linear_3383_11434)'
        />
        <path
          d='M140.332 198.142L132.43 198.01L132.563 190.108L140.464 190.241L140.332 198.142Z'
          fill='url(#paint83_linear_3383_11434)'
        />
        <path
          d='M108.859 193.398L107.876 201.24L100.035 200.257L101.018 192.416L108.859 193.398Z'
          fill='url(#paint84_linear_3383_11434)'
        />
        <path
          d='M101.016 199.495L100.033 207.336L92.1918 206.353L93.1746 198.512L101.016 199.495Z'
          fill='url(#paint85_linear_3383_11434)'
        />
        <path
          d='M93.1722 205.591L92.1893 213.432L84.3482 212.449L85.3311 204.608L93.1722 205.591Z'
          fill='url(#paint86_linear_3383_11434)'
        />
        <path
          d='M84.5521 211.95L83.5692 219.791L75.7281 218.808L76.711 210.967L84.5521 211.95Z'
          fill='url(#paint87_linear_3383_11434)'
        />
        <path
          d='M258.934 300.46L266.74 301.69L265.511 309.496L257.704 308.266L258.934 300.46Z'
          fill='url(#paint88_linear_3383_11434)'
        />
        <path
          d='M264.78 308.492L272.586 309.722L271.356 317.528L263.55 316.298L264.78 308.492Z'
          fill='url(#paint89_linear_3383_11434)'
        />
        <path
          d='M270.626 316.524L278.432 317.753L277.202 325.56L269.396 324.33L270.626 316.524Z'
          fill='url(#paint90_linear_3383_11434)'
        />
        <path
          d='M276.71 325.34L284.516 326.57L283.287 334.376L275.48 333.146L276.71 325.34Z'
          fill='url(#paint91_linear_3383_11434)'
        />
        <path
          d='M164.439 135.012L163.456 142.853L155.615 141.87L156.598 134.029L164.439 135.012Z'
          fill='url(#paint92_linear_3383_11434)'
        />
        <path
          d='M156.595 141.108L155.612 148.949L147.771 147.967L148.754 140.126L156.595 141.108Z'
          fill='url(#paint93_linear_3383_11434)'
        />
        <path
          d='M148.752 147.205L147.769 155.046L139.928 154.063L140.91 146.222L148.752 147.205Z'
          fill='url(#paint94_linear_3383_11434)'
        />
        <path
          d='M140.131 153.564L139.149 161.405L131.307 160.422L132.29 152.581L140.131 153.564Z'
          fill='url(#paint95_linear_3383_11434)'
        />
        <path
          d='M199.627 127.804L207.452 128.909L206.347 136.734L198.522 135.629L199.627 127.804Z'
          fill='url(#paint96_linear_3383_11434)'
        />
        <path
          d='M205.6 135.742L213.425 136.847L212.32 144.672L204.495 143.567L205.6 135.742Z'
          fill='url(#paint97_linear_3383_11434)'
        />
        <path
          d='M211.573 143.679L219.398 144.784L218.293 152.609L210.468 151.504L211.573 143.679Z'
          fill='url(#paint98_linear_3383_11434)'
        />
        <path
          d='M217.798 152.398L225.622 153.503L224.517 161.327L216.693 160.222L217.798 152.398Z'
          fill='url(#paint99_linear_3383_11434)'
        />
        <path
          d='M242.627 181.142L249.974 184.052L247.064 191.399L239.717 188.488L242.627 181.142Z'
          fill='url(#paint100_linear_3383_11434)'
        />
        <path
          d='M246.571 190.259L253.918 193.17L251.007 200.517L243.66 197.606L246.571 190.259Z'
          fill='url(#paint101_linear_3383_11434)'
        />
        <path
          d='M250.514 199.377L257.861 202.288L254.95 209.635L247.603 206.724L250.514 199.377Z'
          fill='url(#paint102_linear_3383_11434)'
        />
        <path
          d='M254.518 209.313L261.865 212.224L258.954 219.57L251.607 216.66L254.518 209.313Z'
          fill='url(#paint103_linear_3383_11434)'
        />
        <path
          d='M245.519 162.872L247.166 155.143L254.895 156.789L253.248 164.518L245.519 162.872Z'
          fill='url(#paint104_linear_3383_11434)'
        />
        <path
          d='M253.853 157.465L255.499 149.736L263.228 151.383L261.582 159.112L253.853 157.465Z'
          fill='url(#paint105_linear_3383_11434)'
        />
        <path
          d='M262.187 152.059L263.833 144.33L271.562 145.976L269.916 153.705L262.187 152.059Z'
          fill='url(#paint106_linear_3383_11434)'
        />
        <path
          d='M271.317 146.456L272.963 138.727L280.692 140.373L279.046 148.102L271.317 146.456Z'
          fill='url(#paint107_linear_3383_11434)'
        />
        <path
          d='M278.239 218.376L277.361 210.523L285.214 209.644L286.093 217.498L278.239 218.376Z'
          fill='url(#paint108_linear_3383_11434)'
        />
        <path
          d='M284.439 210.615L283.561 202.761L291.414 201.883L292.293 209.736L284.439 210.615Z'
          fill='url(#paint109_linear_3383_11434)'
        />
        <path
          d='M290.639 202.853L289.761 195L297.614 194.121L298.493 201.975L290.639 202.853Z'
          fill='url(#paint110_linear_3383_11434)'
        />
        <path
          d='M279.015 249.879L278.524 257.766L286.411 258.257L286.902 250.37L279.015 249.879Z'
          fill='url(#paint111_linear_3383_11434)'
        />
        <path
          d='M285.59 257.326L285.099 265.213L292.986 265.704L293.477 257.817L285.59 257.326Z'
          fill='url(#paint112_linear_3383_11434)'
        />
        <path
          d='M292.164 264.773L291.674 272.66L299.561 273.151L300.052 265.264L292.164 264.773Z'
          fill='url(#paint113_linear_3383_11434)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_3383_11434'
          x1='74.4222'
          y1='277.001'
          x2='48.2203'
          y2='284.374'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_3383_11434'
          x1='74.4222'
          y1='277.001'
          x2='48.2203'
          y2='284.374'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_3383_11434'
          x1='74.4222'
          y1='277.001'
          x2='48.2203'
          y2='284.374'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_3383_11434'
          x1='161.311'
          y1='309.144'
          x2='147.745'
          y2='302.538'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_3383_11434'
          x1='161.311'
          y1='309.144'
          x2='147.745'
          y2='302.538'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_3383_11434'
          x1='161.311'
          y1='309.144'
          x2='147.745'
          y2='302.538'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_3383_11434'
          x1='131.353'
          y1='399.024'
          x2='116.562'
          y2='402.005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_3383_11434'
          x1='131.353'
          y1='399.024'
          x2='116.562'
          y2='402.005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_3383_11434'
          x1='131.353'
          y1='399.024'
          x2='116.562'
          y2='402.005'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_3383_11434'
          x1='197.603'
          y1='367.927'
          x2='186.287'
          y2='357.946'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_3383_11434'
          x1='197.603'
          y1='367.927'
          x2='186.287'
          y2='357.946'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_3383_11434'
          x1='197.603'
          y1='367.927'
          x2='186.287'
          y2='357.946'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_3383_11434'
          x1='297.962'
          y1='354.8'
          x2='286.647'
          y2='344.819'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_3383_11434'
          x1='297.962'
          y1='354.8'
          x2='286.647'
          y2='344.819'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_3383_11434'
          x1='297.962'
          y1='354.8'
          x2='286.647'
          y2='344.819'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint15_linear_3383_11434'
          x1='244.65'
          y1='278.947'
          x2='238.091'
          y2='295.908'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint16_linear_3383_11434'
          x1='244.65'
          y1='278.947'
          x2='238.091'
          y2='295.908'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint17_linear_3383_11434'
          x1='244.65'
          y1='278.947'
          x2='238.091'
          y2='295.908'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint18_linear_3383_11434'
          x1='121.953'
          y1='170.935'
          x2='115.394'
          y2='187.896'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint19_linear_3383_11434'
          x1='121.953'
          y1='170.935'
          x2='115.394'
          y2='187.896'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint20_linear_3383_11434'
          x1='121.953'
          y1='170.935'
          x2='115.394'
          y2='187.896'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint21_linear_3383_11434'
          x1='190.319'
          y1='111.758'
          x2='172.88'
          y2='129.224'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint22_linear_3383_11434'
          x1='190.319'
          y1='111.758'
          x2='172.88'
          y2='129.224'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint23_linear_3383_11434'
          x1='190.319'
          y1='111.758'
          x2='172.88'
          y2='129.224'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint24_linear_3383_11434'
          x1='238.905'
          y1='167.965'
          x2='226.595'
          y2='176.816'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint25_linear_3383_11434'
          x1='238.905'
          y1='167.965'
          x2='226.595'
          y2='176.816'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint26_linear_3383_11434'
          x1='238.905'
          y1='167.965'
          x2='226.595'
          y2='176.816'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint27_linear_3383_11434'
          x1='313.666'
          y1='279.158'
          x2='301.356'
          y2='288.009'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint28_linear_3383_11434'
          x1='313.666'
          y1='279.158'
          x2='301.356'
          y2='288.009'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint29_linear_3383_11434'
          x1='313.666'
          y1='279.158'
          x2='301.356'
          y2='288.009'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint30_linear_3383_11434'
          x1='313.608'
          y1='179.36'
          x2='302.536'
          y2='189.718'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint31_linear_3383_11434'
          x1='313.608'
          y1='179.36'
          x2='302.536'
          y2='189.718'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint32_linear_3383_11434'
          x1='313.608'
          y1='179.36'
          x2='302.536'
          y2='189.718'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint33_linear_3383_11434'
          x1='299.499'
          y1='125.469'
          x2='288.427'
          y2='135.827'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint34_linear_3383_11434'
          x1='299.499'
          y1='125.469'
          x2='288.427'
          y2='135.827'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint35_linear_3383_11434'
          x1='299.499'
          y1='125.469'
          x2='288.427'
          y2='135.827'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint36_linear_3383_11434'
          x1='262.122'
          y1='226.564'
          x2='271.251'
          y2='243.823'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint37_linear_3383_11434'
          x1='262.122'
          y1='226.564'
          x2='271.251'
          y2='243.823'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint38_linear_3383_11434'
          x1='262.122'
          y1='226.564'
          x2='271.251'
          y2='243.823'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint39_linear_3383_11434'
          x1='67.8579'
          y1='222.246'
          x2='63.4649'
          y2='233.606'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint40_linear_3383_11434'
          x1='67.8579'
          y1='222.246'
          x2='63.4649'
          y2='233.606'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint41_linear_3383_11434'
          x1='67.8579'
          y1='222.246'
          x2='63.4649'
          y2='233.606'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint42_linear_3383_11434'
          x1='203.603'
          y1='229.095'
          x2='170.438'
          y2='238.427'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint43_linear_3383_11434'
          x1='203.603'
          y1='229.095'
          x2='170.438'
          y2='238.427'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint44_linear_3383_11434'
          x1='203.603'
          y1='229.095'
          x2='170.438'
          y2='238.427'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint45_linear_3383_11434'
          x1='79.4799'
          y1='324.465'
          x2='68.0592'
          y2='327.247'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint46_linear_3383_11434'
          x1='79.4799'
          y1='324.465'
          x2='68.0592'
          y2='327.247'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint47_linear_3383_11434'
          x1='79.4799'
          y1='324.465'
          x2='68.0592'
          y2='327.247'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint48_linear_3383_11434'
          x1='79.4799'
          y1='324.465'
          x2='68.0592'
          y2='327.247'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint49_linear_3383_11434'
          x1='79.4799'
          y1='324.465'
          x2='68.0592'
          y2='327.247'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint50_linear_3383_11434'
          x1='165.273'
          y1='274.74'
          x2='175.245'
          y2='280.052'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint51_linear_3383_11434'
          x1='165.273'
          y1='274.74'
          x2='175.245'
          y2='280.052'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint52_linear_3383_11434'
          x1='165.273'
          y1='274.74'
          x2='175.245'
          y2='280.052'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint53_linear_3383_11434'
          x1='165.273'
          y1='274.74'
          x2='175.245'
          y2='280.052'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint54_linear_3383_11434'
          x1='166.774'
          y1='338.906'
          x2='176.311'
          y2='332.848'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint55_linear_3383_11434'
          x1='166.774'
          y1='338.906'
          x2='176.311'
          y2='332.848'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint56_linear_3383_11434'
          x1='166.774'
          y1='338.906'
          x2='176.311'
          y2='332.848'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint57_linear_3383_11434'
          x1='166.774'
          y1='338.906'
          x2='176.311'
          y2='332.848'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint58_linear_3383_11434'
          x1='163.052'
          y1='390.444'
          x2='158.163'
          y2='380.257'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint59_linear_3383_11434'
          x1='163.052'
          y1='390.444'
          x2='158.163'
          y2='380.257'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint60_linear_3383_11434'
          x1='163.052'
          y1='390.444'
          x2='158.163'
          y2='380.257'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint61_linear_3383_11434'
          x1='163.052'
          y1='390.444'
          x2='158.163'
          y2='380.257'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint62_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint63_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint64_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint65_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint66_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint67_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint68_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint69_linear_3383_11434'
          x1='123.39'
          y1='264.698'
          x2='119.451'
          y2='253.623'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint70_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint71_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint72_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint73_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint74_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint75_linear_3383_11434'
          x1='224.499'
          y1='327.931'
          x2='214.557'
          y2='321.659'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint76_linear_3383_11434'
          x1='218.921'
          y1='258.595'
          x2='210.61'
          y2='266.696'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint77_linear_3383_11434'
          x1='218.921'
          y1='258.595'
          x2='210.61'
          y2='266.696'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint78_linear_3383_11434'
          x1='218.921'
          y1='258.595'
          x2='210.61'
          y2='266.696'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint79_linear_3383_11434'
          x1='218.921'
          y1='258.595'
          x2='210.61'
          y2='266.696'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint80_linear_3383_11434'
          x1='149.639'
          y1='199.596'
          x2='141.328'
          y2='207.697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint81_linear_3383_11434'
          x1='149.639'
          y1='199.596'
          x2='141.328'
          y2='207.697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint82_linear_3383_11434'
          x1='149.639'
          y1='199.596'
          x2='141.328'
          y2='207.697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint83_linear_3383_11434'
          x1='149.639'
          y1='199.596'
          x2='141.328'
          y2='207.697'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint84_linear_3383_11434'
          x1='87.0007'
          y1='202.854'
          x2='94.1589'
          y2='211.989'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint85_linear_3383_11434'
          x1='87.0007'
          y1='202.854'
          x2='94.1589'
          y2='211.989'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint86_linear_3383_11434'
          x1='87.0007'
          y1='202.854'
          x2='94.1589'
          y2='211.989'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint87_linear_3383_11434'
          x1='87.0007'
          y1='202.854'
          x2='94.1589'
          y2='211.989'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint88_linear_3383_11434'
          x1='267.696'
          y1='322.606'
          x2='277.052'
          y2='315.739'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint89_linear_3383_11434'
          x1='267.696'
          y1='322.606'
          x2='277.052'
          y2='315.739'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint90_linear_3383_11434'
          x1='267.696'
          y1='322.606'
          x2='277.052'
          y2='315.739'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint91_linear_3383_11434'
          x1='267.696'
          y1='322.606'
          x2='277.052'
          y2='315.739'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint92_linear_3383_11434'
          x1='142.58'
          y1='144.468'
          x2='149.738'
          y2='153.603'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint93_linear_3383_11434'
          x1='142.58'
          y1='144.468'
          x2='149.738'
          y2='153.603'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint94_linear_3383_11434'
          x1='142.58'
          y1='144.468'
          x2='149.738'
          y2='153.603'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint95_linear_3383_11434'
          x1='142.58'
          y1='144.468'
          x2='149.738'
          y2='153.603'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint96_linear_3383_11434'
          x1='208.741'
          y1='149.807'
          x2='217.986'
          y2='142.793'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint97_linear_3383_11434'
          x1='208.741'
          y1='149.807'
          x2='217.986'
          y2='142.793'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint98_linear_3383_11434'
          x1='208.741'
          y1='149.807'
          x2='217.986'
          y2='142.793'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint99_linear_3383_11434'
          x1='208.741'
          y1='149.807'
          x2='217.986'
          y2='142.793'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint100_linear_3383_11434'
          x1='246.322'
          y1='204.669'
          x2='256.956'
          y2='200.02'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint101_linear_3383_11434'
          x1='246.322'
          y1='204.669'
          x2='256.956'
          y2='200.02'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint102_linear_3383_11434'
          x1='246.322'
          y1='204.669'
          x2='256.956'
          y2='200.02'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint103_linear_3383_11434'
          x1='246.322'
          y1='204.669'
          x2='256.956'
          y2='200.02'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint104_linear_3383_11434'
          x1='268.103'
          y1='155.311'
          x2='261.748'
          y2='145.6'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint105_linear_3383_11434'
          x1='268.103'
          y1='155.311'
          x2='261.748'
          y2='145.6'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint106_linear_3383_11434'
          x1='268.103'
          y1='155.311'
          x2='261.748'
          y2='145.6'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint107_linear_3383_11434'
          x1='268.103'
          y1='155.311'
          x2='261.748'
          y2='145.6'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint108_linear_3383_11434'
          x1='294.164'
          y1='207.939'
          x2='285.099'
          y2='200.756'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint109_linear_3383_11434'
          x1='294.164'
          y1='207.939'
          x2='285.099'
          y2='200.756'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint110_linear_3383_11434'
          x1='294.164'
          y1='207.939'
          x2='285.099'
          y2='200.756'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint111_linear_3383_11434'
          x1='295.435'
          y1='259.52'
          x2='286.734'
          y2='267.14'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint112_linear_3383_11434'
          x1='295.435'
          y1='259.52'
          x2='286.734'
          y2='267.14'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <linearGradient
          id='paint113_linear_3383_11434'
          x1='295.435'
          y1='259.52'
          x2='286.734'
          y2='267.14'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#391998' stopOpacity='0' />
          <stop offset='1' stopColor='#391998' stopOpacity='0.4' />
        </linearGradient>
        <clipPath id='clip0_3383_11434'>
          <rect width='390' height='493' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function OnboardImage1() {
  return (
    <>
      <div className='show-on-dark-theme'>
        <OnboardImage1Dark />
      </div>
      <div className='show-on-light-theme'>
        <OnboardImage1Light />
      </div>
    </>
  )
}
